export default {
  'header.homepage': '홈페이지',
  'header.workspace': '작업 공간',
  'login.title': 'Seedance',
  'login.welcome': 'Seedance에 오신 것을 환영합니다',
  'login.description': 'Seedance는 AI 비디오 생성 플랫폼입니다. 안전하고 편리한 창작 서비스. 언제 어디서나 모든 파일에 접근할 수 있습니다.',
  'login.email.placeholder': '이메일 또는 사용자 이름',
  'login.password.placeholder': '비밀번호',
  'login.button': '로그인',
  'login.loading': '로그인 중...',
  'login.divider': '또는',
  'login.signup': '계정이 없으신가요?',
  'login.signup.link': '회원가입',
  'login.error.default': '로그인에 실패했습니다. 나중에 다시 시도해주세요',
  'login.success': '로그인 성공',
  'login.forgotPassword': '비밀번호를 잊으셨나요?',
  'login.forgotPassword.link': '여기서 재설정',
  'login.rememberPassword': '비밀번호 기억',
  'login.social.comingSoon': '해당 로그인 방식은 준비 중입니다',
  'captcha.placeholder': '캡차 코드',
  'captcha.refresh': '캡차 새로고침',
  'auth.modal.title': '로그인이 필요합니다',
  'auth.modal.content': '로그인이 만료되었거나 로그인되어 있지 않습니다. 계속하려면 로그인해 주세요.',
  'auth.modal.ok': '로그인하기',
  'auth.modal.cancel': '나중에',
  'signup.page.title': '회원가입 - Seedance',
  'signup.title': 'Seedance',
  'signup.welcome': 'Seedance에 오신 것을 환영합니다',
  'signup.description': '계정을 만들고 AI 창작 여정을 시작하세요',
  'signup.feature.ai': 'AI 기반',
  'signup.feature.video': '비디오 제작',
  'signup.feature.fast': '빠른 생성',
  'signup.feature.creative': '무한한 창의성',
  'signup.username.placeholder': '사용자 이름 입력',
  'signup.email.placeholder': '이메일 입력',
  'signup.password.placeholder': '비밀번호 입력',
  'signup.confirmPassword.placeholder': '비밀번호 확인',
  'signup.inviteCode.placeholder': '초대 코드 (선택)',
  'signup.button': '가입하기',
  'signup.loading': '가입 중...',
  'signup.login': '이미 계정이 있으신가요?',
  'signup.login.link': '로그인',
  'signup.error.passwordMismatch': '비밀번호가 일치하지 않습니다',
  'signup.error.default': '가입에 실패했습니다. 나중에 다시 시도해주세요',
  'signup.success': '가입이 완료되었습니다',
  'resetPassword.page.title': '비밀번호 재설정 - Seedance',
  'resetPassword.page.description': 'Seedance 계정 비밀번호 재설정',
  'resetPassword.title': '비밀번호 재설정',
  'resetPassword.email.placeholder': '이메일 주소 입력',
  'resetPassword.code.placeholder': '인증 코드 입력',
  'resetPassword.password.placeholder': '새 비밀번호 입력',
  'resetPassword.button': '비밀번호 재설정',
  'resetPassword.button.loading': '재설정 중...',
  'resetPassword.backToLogin': '로그인으로 돌아가기',
  'resetPassword.sendCode': '인증 코드 받기',
  'resetPassword.sendCode.sending': '전송 중...',
  'resetPassword.sendCode.retry': '{seconds}초 후 재시도',
  'resetPassword.error.emailRequired': '이메일 주소를 입력해주세요',
  'resetPassword.error.codeRequired': '인증 코드를 입력해주세요',
  'resetPassword.error.passwordRequired': '새 비밀번호를 입력해주세요',
  'resetPassword.error.passwordLength': '비밀번호는 6-20자 사이여야 합니다',
  'resetPassword.error.codeLength': '인증 코드는 6자리여야 합니다',
  'resetPassword.success.codeSent': '인증 코드가 이메일로 전송되었습니다',
  'resetPassword.success.reset': '비밀번호가 성공적으로 재설정되었습니다',
  'resetPassword.error.sendFailed': '인증 코드 전송에 실패했습니다. 나중에 다시 시도해주세요',
  'resetPassword.error.resetFailed': '비밀번호 재설정에 실패했습니다. 나중에 다시 시도해주세요',
  'resetPassword.error.incomplete': '모든 필수 항목을 입력해주세요',
  'resetPassword.subtitle': '이메일 주소와 새 비밀번호를 입력하여 계정 접근을 재설정하세요.',
  'resetPassword.email.label': '이메일',
  'resetPassword.code.label': '인증 코드',
  'resetPassword.password.label': '새 비밀번호',
  'resetPassword.success.title': '재설정 완료',
  'resetPassword.success.description': '비밀번호가 성공적으로 업데이트되었습니다. 이제 새 비밀번호로 로그인할 수 있습니다.',
  'resetPassword.goToLogin': '로그인하기',
  'resetPassword.promo.title': '계정을 보호하고, 창작물을 지키세요.',
  'resetPassword.promo.description': '은행 수준의 보안 프로토콜을 구현하여 귀하의 데이터와 창작물이 오직 귀하의 것으로 유지되도록 보장합니다.',
  'signup.username.rule.length': '사용자 이름은 4-10자여야 합니다',
  'signup.username.rule.format': '문자, 숫자, 밑줄 및 하이픈만 허용됩니다',
  'signup.password.rule.length': '비밀번호는 6-20자여야 합니다',
  'signup.password.rule.lowercase': '소문자를 포함해야 합니다',
  'signup.password.rule.uppercase': '대문자를 포함해야 합니다',
  'signup.password.rule.number': '숫자를 포함해야 합니다',
  'signup.password.rule.special': '특수 문자를 포함해야 합니다',
  'signup.verificationCode.placeholder': '인증 코드를 입력하세요',
  'signup.verificationCode.send': '코드 받기',
  'signup.verificationCode.sending': '전송 중...',
  'signup.verificationCode.retry': '{seconds}초 후 재시도',
  'signup.verificationCode.success': '인증 코드가 전송되었습니다',
  'signup.verificationCode.error': '코드 전송 실패',
  'signup.verificationCode.required': '인증 코드를 입력해 주세요',
  'signup.verificationCode.invalid': '인증 코드 형식이 올바르지 않습니다',
  'signup.error.emailRequired': '이메일 주소를 입력해주세요',
  'signup.announcement': '오늘은 등록 기능이 점검 중입니다!',
  'sidebar.create': '작성',
  'sidebar.allFiles': '모든 파일',
  'sidebar.starred': '즐겨찾기',
  'sidebar.folders': '폴더',
  'sidebar.trash': '휴지통',
  'sidebar.decrypt': '복호화 도구',
  'sidebar.promptMarket': '프롬프트 마켓',
  'sidebar.channels': '생성 채널',
  'sidebar.dailyChallenge': '데일리 챌린지',
  'sidebar.mediaTools': '미디어 도구',
  'sidebar.storageNodes': '스토리지 노드',
  'create.tab.textToImage': '텍스트에서 이미지',
  'create.tab.textToVideo': '텍스트에서 비디오',
  'create.tab.imageToImage': '이미지에서 이미지',
  'create.tab.imageToVideo': '이미지에서 비디오',
  'create.tab.seedanceVideo': 'Seedance 이미지→비디오',
  'create.seedance.title': 'Seedance 이미지→비디오',
  'create.seedance.subtitle': 'ByteDance Doubao Seedance 1.5, 이미지 기반 숏폼 비디오 생성',
  'create.seedance.noModel': '사용 가능한 Seedance 모델이 없습니다. 관리자에서 설정해 주세요.',
  'create.seedance.cameraFixed': '카메라 고정',
  'create.seedance.cameraFixed.true': '예(고정)',
  'create.seedance.cameraFixed.false': '아니오(동적)',
  'create.seedance.watermark': '워터마크 추가',
  'create.seedance.watermark.true': '예',
  'create.seedance.watermark.false': '아니오',
  'create.textToImage.title': '텍스트에서 이미지',
  'create.textToImage.subtitle': '설명을 입력하고 AI가 당신의 마음속 이미지를 그리도록 하세요',
  'create.textToImage.description': '텍스트 설명에서 이미지를 생성합니다. 이 기능은 개발 중입니다...',
  'create.textToVideo.title': '텍스트에서 비디오',
  'create.textToVideo.subtitle': '장면 설명과 카메라 제어를 입력하여 고품질 비디오 생성',
  'create.textToVideo.description': '텍스트 설명에서 비디오를 생성합니다. 이 기능은 개발 중입니다...',
  'create.imageToImage.title': '이미지에서 이미지',
  'create.imageToImage.description': '참조 이미지에서 새로운 이미지를 생성합니다. 이 기능은 개발 중입니다...',
  'create.imageToVideo.title': '이미지에서 비디오',
  'create.imageToVideo.description': '참조 이미지에서 비디오를 생성합니다. 이 기능은 개발 중입니다...',
  'sidebar.feedback': '피드백',
  'sidebar.about': '정보',
  'sidebar.productLog': '제품 업데이트',
  'promptMarket.title': 'Prompt Market',
  'promptMarket.subtitle': '탑 크리에이터의 AI 영감으로 무한한 창의력을 발휘하세요',
  'promptMarket.searchPlaceholder': '프롬프트, 스타일, 모델 검색...',
  'promptMarket.search': '검색',
  'promptMarket.all': '전체',
  'promptMarket.tabAll': '추천',
  'promptMarket.tabImage': '문생도',
  'promptMarket.tabVideo': '문생영상',
  'promptMarket.tabAudio': '문생음악',
  'promptMarket.sortLatest': '최신',
  'promptMarket.sortHot': '인기',
  'promptMarket.sortSales': '판매순',
  'promptMarket.publish': '작품 발행',
  'promptMarket.empty': '관련 상품이 없습니다. 첫 작품을 발행해 보세요!',
  'promptMarket.free': '무료',
  'promptMarket.token': 'TOKEN',
  'promptMarket.loadFailed': '로드 실패',
  'promptMarket.listSuccess': '등록 완료',
  'promptMarket.listFailed': '등록 실패',
  'market.label': '프롬프트 마켓',
  'market.h1': '당신의',
  'market.h1.highlight': '창의력을 발휘하세요.',
  'market.sub': 'AI 프롬프트 프리미엄 플랫폼. 이미지·영상·음악 지원. OpenAI, Google, Midjourney, Runway, Kling, Luma, Suno, ElevenLabs 등 검증된 레시피로 시행착오 없이 제작하세요.',
  'market.providers.title': '주요 모델 및 플랫폼과 호환',
  'market.card1.title': '즉시 연동',
  'market.card1.desc': '프롬프트 학습 곡선을 건너뛰고, 검증된 프롬프트를 원클릭으로 워크플로에 가져오세요.',
  'market.card2.title': '창의력 수익화',
  'market.card2.desc': '최고의 프롬프트를 수동 수입으로. AI 전문성으로 수익을 얻는 수천 명의 크리에이터와 함께하세요.',
  'market.card3.title': '품질 보증',
  'market.card3.desc': '모든 등록물은 수동 검토 및 테스트됩니다. 다양한 모델에서 일관된 결과를 보장합니다.',
  'market.card4.title': '랩 탐험',
  'market.card4.desc': '커뮤니티가 생성한 10,000개 이상의 에셋을 발견하세요.',
  'market.cta': '프롬프트 마켓 시작',
  'home.mediaTools.title': '미디어 도구',
  'home.mediaTools.subtitle': '온라인 사용, 설치 불필요. 이미지·영상·음악 파일을 쉽게 처리하세요.',
  'home.mediaTools.toolSuffix': ' 도구',
  'home.mediaTools.imageCompress.title': '이미지 압축',
  'home.mediaTools.imageCompress.description': '화질을 유지하며 스마트 압축. 일괄 처리 지원.',
  'home.mediaTools.videoCompress.title': '영상 압축',
  'home.mediaTools.videoCompress.description': '해상도·비트레이트 커스텀. 다양한 형식 지원.',
  'home.mediaTools.audioCompress.title': '오디오 압축',
  'home.mediaTools.audioCompress.description': '음질 유지하며 파일 크기 최적화. MP3, AAC 등 지원.',
  'filelist.column.name': '이름',
  'filelist.column.size': '크기',
  'filelist.column.updateTime': '수정일',
  'filelist.column.recycletime': '삭제일',
  'filelist.column.actions': '작업',
  'filelist.total': '총 {total}개 항목',
  'filelist.action.upload': '업로드',
  'filelist.action.newFolder': '새 폴더',
  'filelist.action.refresh': '새로고침',
  'filelist.action.search': '파일 검색',
  'filelist.action.batchDownload': '다운로드',
  'filelist.action.batchDelete': '삭제',
  'filelist.action.download': '다운로드',
  'filelist.action.preview': '미리보기',
  'filelist.action.rename': '이름 변경',
  'filelist.selected': '{count}개 선택됨',
  'filelist.modal.rename.title': '이름 변경',
  'filelist.modal.rename.placeholder': '새 이름 입력',
  'filelist.modal.rename.ok': '확인',
  'filelist.modal.rename.cancel': '취소',
  'page.cloudDrive.title': '내 클라우드 드라이브',
  'page.cloudDrive.description': 'AIMATEX 클라우드 드라이브 - 안전하게 파일을 저장하고 관리하세요',
  'modal.fileUpload.title': '파일 업로드',
  'modal.fileUpload.dragText': '여기에 파일을 끌어다 놓거나 클릭하여 업로드',
  'modal.fileUpload.start': '업로드 시작',
  'modal.fileUpload.cancel': '취소',
  'modal.fileUpload.clear': '목록 지우기',
  'modal.fileUpload.encrypt': '선택한 파일 암호화',
  'modal.fileUpload.addMore': '추가',
  'modal.fileUpload.remove': '제거',
  'modal.fileUpload.duplicate.title': '파일이 이미 존재합니다',
  'modal.fileUpload.duplicate.skip': '건너뛰기',
  'modal.fileUpload.duplicate.replace': '교체',
  'modal.fileUpload.duplicate.rename': '이름 변경',
  'modal.fileUpload.status.pending': '대기 중',
  'modal.fileUpload.status.uploading': '업로드 중',
  'modal.fileUpload.status.success': '완료',
  'modal.fileUpload.status.error': '오류',
  'modal.fileUpload.status.cancelled': '취소됨',
  'modal.fileUpload.status.duplicated': '중복',
  'modal.fileUpload.table.filename': '파일명',
  'modal.fileUpload.table.size': '크기',
  'modal.fileUpload.table.status': '상태',
  'modal.fileUpload.table.progress': '진행률',
  'modal.fileUpload.table.actions': '작업',
  'modal.fileUpload.speed': '업로드 속도',
  'modal.fileUpload.remainingTime': '남은 시간',
  'modal.fileUpload.total.progress': '전체 진행률',
  'modal.fileUpload.error.message': '업로드 실패: {message}',
  'modal.fileUpload.confirm.clear': '업로드 목록을 지우시겠습니까?',
  'modal.fileUpload.confirm.cancel': '업로드를 취소하시겠습니까?',
  'modal.fileUpload.error.noSelection': '제거할 파일을 선택해주세요',
  'modal.fileUpload.error.noEncryption': '암호화할 파일을 선택해주세요',
  'modal.fileUpload.error.noClear': '지울 파일이 없습니다',
  'modal.fileUpload.error.noStart': '업로드할 파일이 없습니다',
  'modal.fileUpload.error.noCancel': '취소할 업로드가 없습니다',
  'modal.fileUpload.error.fileSize': '파일 크기가 제한을 초과했습니다',
  'modal.fileUpload.error.fileType': '지원하지 않는 파일 형식입니다',
  'modal.fileUpload.error.maxCount': '최대 파일 수를 초과했습니다',
  'modal.fileUpload.clear.mobile': '지우기',
  'modal.fileUpload.encrypt.mobile': '암호화',
  'modal.fileUpload.addMore.mobile': '추가',
  'productLog.title': '제품 업데이트',
  // 보안 기능
  'security.features.title': '보안 기능',
  'security.features.localDecryption.title': '로컬 복호화',
  'security.features.localDecryption.description': '모든 복호화 작업은 브라우저에서 로컬로 수행되어 파일 내용과 비밀번호가 장치를 벗어나지 않습니다',
  'security.features.militaryEncryption.title': '군사급 암호화',
  'security.features.militaryEncryption.description': 'AES-256-CBC 암호화 알고리즘 사용. 알려진 모든 공격에 대응할 수 있는 가장 안전한 대칭 암호화 표준입니다',
  'security.features.privacyProtection.title': '개인정보 보호',
  'security.features.privacyProtection.description': '엄격한 개인정보 보호 메커니즘으로 복호화 비밀번호를 저장하지 않고 파일 내용도 기록하지 않습니다',
  'security.features.smartDecryption.title': '스마트 청크 복호화',
  'security.features.smartDecryption.description': '스마트 청크 복호화 기술로 복호화 속도를 크게 향상시키면서 메모리 사용량을 줄입니다',
  'security.features.learnMore': '자세히 알아보기',
  'security.features.modal.title': '보안 기능 상세',
  'security.features.modal.close': '닫기',
  // 보안 팁 모달
  'decrypt.security.modal.title': '보안 알림',
  'decrypt.security.modal.description': '모든 복호화 작업은 로컬에서 수행되며, 비밀번호와 파일 내용이 서버로 전송되지 않습니다',
  'decrypt.security.modal.vip.title': 'VIP 사용자 혜택:',
  'decrypt.security.modal.vip.feature1': '모든 크기의 파일 복호화 가능',
  'decrypt.security.modal.vip.feature2': '스마트 청크 복호화로 효율성 향상',
  'decrypt.security.modal.vip.feature3': '대용량 파일 일괄 복호화 지원',
  'decrypt.security.modal.free.title': '중요: 복호화 과정에는 파일 크기의 약 3배에 해당하는 브라우저 메모리가 필요합니다.',
  'decrypt.security.modal.free.feature1': '무료 사용자는 파일당 4GB 제한',
  'decrypt.security.modal.free.feature2': 'VIP로 업그레이드하여 용량 제한 해제',
  'decrypt.security.modal.free.feature3': '브라우저가 충돌하는 경우 VIP의 청크 복호화 기능 사용을 고려하세요',
  // CBC 암호화 다이어그램
  'security.diagram.plaintext.block1': '평문 블록 1',
  'security.diagram.plaintext.block2': '평문 블록 2',
  'security.diagram.ciphertext.block1': '암호문 블록 1',
  'security.diagram.ciphertext.block2': '암호문 블록 2',
  'security.diagram.key': '키',
  'security.diagram.aes.encryption': 'AES 암호화',
  'security.diagram.xor.operation': 'XOR 연산',
  'security.diagram.iv': '초기화 벡터',
  // Smart Chunk Decryption
  'security.features.chunk.title': '스마트 청크 복호화 기술',
  'security.features.chunk.what': '스마트 청크 복호화란 무엇인가요?',
  'security.features.chunk.description': '스마트 청크 복호화는 대용량 파일을 위해 최적화된 기술로, 파일을 여러 블록으로 나누어 병렬 처리하며 다음과 같은 특징이 있습니다:',
  'security.features.chunk.feature1.title': '동적 분할',
  'security.features.chunk.feature1.desc': '파일 크기와 시스템 메모리를 기반으로 블록 크기를 자동 조정',
  'security.features.chunk.feature2.title': '병렬 처리',
  'security.features.chunk.feature2.desc': '여러 데이터 블록을 동시에 복호화하여 멀티코어 CPU를 최대한 활용',
  'security.features.chunk.feature3.title': '메모리 최적화',
  'security.features.chunk.feature3.desc': '스트리밍 처리를 통해 메모리 사용을 제어하여 오버플로우 방지',
  'security.features.chunk.feature4.title': '재개 지원',
  'security.features.chunk.feature4.desc': '중단 후 계속 진행을 지원하여 오류 허용성 향상',
  'security.features.chunk.how': '작동 방식',
  'security.features.chunk.process': '스마트 청크 복호화 프로세스는 다음 단계를 포함합니다:',
  'security.features.chunk.step1': '파일 분석: 최적의 블록 크기와 수 계산',
  'security.features.chunk.step2': '데이터 분할: 암호화된 파일을 동일한 크기의 블록으로 분할',
  'security.features.chunk.step3': '병렬 복호화: 여러 블록을 동시에 복호화',
  'security.features.chunk.step4': '스트림 쓰기: 복호화된 블록을 순차적으로 기록',
  'security.features.chunk.code': '{code}',
  'security.features.chunk.performance': '성능 이점',
  'security.features.chunk.performance.intro': '전통적인 복호화와 비교하여 스마트 청크 복호화는 다음과 같은 중요한 이점이 있습니다:',
  'security.features.chunk.performance.point1': '메모리 사용량 최대 90% 감소, 4GB 파일에 400MB만 필요',
  'security.features.chunk.performance.point2': '멀티코어 CPU를 활용하여 3-5배 빠른 복호화 속도',
  'security.features.chunk.performance.point3': '대용량 파일(>4GB) 복호화 지원, 브라우저 메모리 제한 없음',
  'security.features.chunk.performance.point4': '정확한 진행 상황과 남은 시간을 보여주는 시각적 복호화 프로세스',
  'security.features.chunk.usage': '사용 사례',
  'security.features.chunk.usage.intro': '스마트 청크 복호화는 다음과 같은 시나리오에 특히 적합합니다:',
  'security.features.chunk.usage.point1': '대용량 파일 복호화(예: 비디오, 데이터베이스 백업)',
  'security.features.chunk.usage.point2': '제한된 메모리 장치에서의 복호화 작업',
  'security.features.chunk.usage.point3': '병렬 처리가 필요한 일괄 복호화',
  'security.features.chunk.usage.point4': '실시간 피드백이 필요한 복호화 작업',
  'security.features.chunk.diagram': '스마트 청크 복호화 프로세스 다이어그램',
  'security.features.aes.security': '보안 특성',
  'security.features.aes.security.intro': 'AES-256-CBC는 다음과 같은 다중 보안 보장을 제공합니다:',
  'security.features.aes.security.point1': '256비트 키는 2^256개의 가능한 조합을 제공하며, 슈퍼컴퓨터로도 무차별 대입 공격이 불가능',
  'security.features.aes.security.point2': 'CBC 모드는 동일한 평문 블록이 서로 다른 암호문 블록을 생성하도록 보장하여 암호화의 무작위성을 증가',
  'security.features.aes.security.point3': '초기화 벡터(IV) 사용으로 동일한 키를 사용하더라도 매번 다른 암호화 결과 보장',
  'security.features.aes.security.point4': '군사, 금융 및 기타 높은 보안이 요구되는 분야에서 널리 사용',
  'security.features.aes.diagram': 'CBC 모드 암호화 프로세스 동적 다이어그램',
  'security.features.aes.why': 'AES-256-CBC를 선택한 이유',
  'security.features.aes.why.intro': '다음과 같은 이유로 AES-256-CBC를 암호화 표준으로 선택했습니다:',
  'security.features.aes.why.point1': '광범위하게 검증된 보안성, 현재까지 실용적인 공격 방법 없음',
  'security.features.aes.why.point2': '우수한 성능, 빠른 암호화 및 복호화',
  'security.features.aes.why.point3': '하드웨어 가속 지원, 현대 프로세서에 AES 명령어 세트 내장',
  'security.features.aes.why.point4': '광범위한 도구 지원, 모든 프로그래밍 언어에서 성숙한 구현',
  'security.features.aes.what': 'AES-256-CBC란 무엇인가요?',
  'security.features.aes.description': 'AES-256-CBC는 고급 암호화 표준(Advanced Encryption Standard)의 구현 방식으로, 다음과 같은 특징이 있습니다:',
  'security.features.aes.detail.1': '2001년 미국 국립표준기술연구소(NIST)에서 제정한 대칭 암호화 알고리즘',
  'security.features.aes.detail.2': '256비트 키 길이를 사용하여 최고 수준의 보안성 제공',
  'security.features.aes.detail.3': '암호 블록 체인(Cipher Block Chaining) 모드로 더 강력한 암호화 보안 제공',
  'security.features.aes.how': '작동 방식',
  'security.features.aes.process': 'AES-256-CBC 암호화 프로세스는 다음 단계를 포함합니다:',
  'security.features.aes.step1': '평문 데이터를 고정 크기 블록(128비트)으로 분할',
  'security.features.aes.step2': '무작위 초기화 벡터(IV) 생성',
  'security.features.aes.step3': 'CBC 모드를 사용하여 이전 암호문 블록과 현재 평문 블록을 XOR 연산',
  'security.features.aes.step4': '256비트 키를 사용하여 XOR 결과에 AES 암호화 수행',
  'security.features.aes.example': '암호화 프로세스 예시:',
  // FileList Section
  'decrypt.fileList.column.name': '파일 이름',
  'decrypt.fileList.column.status': '상태',
  'decrypt.fileList.column.actions': '작업',
  'decrypt.fileList.status.pending': '대기 중',
  'decrypt.fileList.status.decrypting': '복호화 중',
  'decrypt.fileList.status.success': '완료됨',
  'decrypt.fileList.status.error': '오류',
  'decrypt.fileList.action.info': '정보',
  'decrypt.fileList.empty': '복호화할 파일이 없습니다',
  'common.unknown': '알 수 없음',
  'common.philosophy': '기술은 인민을 위해 봉사해야 한다',
  'common.speed': '속도',
  'common.timeSpent': '소요 시간',
  'common.remaining': '남은 시간',
  // Upload Section
  'decrypt.upload.dragText': '파일을 클릭하거나 여기로 끌어오세요',
  'decrypt.upload.hint': '.encrypted 파일 일괄 추가 지원, 파일당 최대 {maxSize}',
  'decrypt.upload.button.decrypt': '선택한 파일 복호화',
  'decrypt.upload.button.clear': '목록 지우기',
  // 파일 정보 모달
  'decrypt.fileInfo.modal.title': '파일 정보',
  'decrypt.fileInfo.modal.close': '닫기',
  'decrypt.fileInfo.name': '파일 이름',
  'decrypt.fileInfo.size': '파일 크기',
  'decrypt.fileInfo.type': '파일 유형',
  'decrypt.fileInfo.lastModified': '마지막 수정',
  'decrypt.fileInfo.status': '상태',
  'decrypt.fileInfo.progress': '진행률',
  'decrypt.fileInfo.speed': '속도',
  'decrypt.fileInfo.timeRemaining': '남은 시간',
  'decrypt.fileInfo.timeSpent': '소요 시간',
  'decrypt.fileInfo.error': '오류 메시지',
  'page.decrypt.title': '복호화 도구',
  'page.decrypt.subtitle': '파일을 안전하고 빠르게 복호화',
  'sideMenu.storageInfo.title': '저장 공간',
  'sideMenu.storageInfo.usage': '사용 {used} / 전체 {total}',
  'sideMenu.storageStats.title': '스토리지 통계',
  'sideMenu.storageStats.overview': '개요',
  'sideMenu.storageStats.totalFiles': '총 파일 수',
  'sideMenu.storageStats.totalSize': '총 용량',
  'sideMenu.storageStats.fileTypes': '파일 유형 분포',
  'sideMenu.storageStats.providers': '서비스 제공업체',
  'common.default': '기본값',
  'common.regionCode': '지역 코드',
  'common.nodeType': '노드 유형',
  'common.storageUsed': '사용된 공간',
  'common.storageAvailable': '사용 가능한 공간',
  'common.storageLimit': '총 용량',
  'common.storageUsageDetail': '사용 {used} / 전체 {total}',
  'common.defaultNode': '기본 노드',
  'common.confirm': '확인',
  'common.cancel': '취소',
  'common.latency': '지연 시간',
  'common.retry': '다시 시도',
  'cloudDrive.nodeSelect.title': '스토리지 노드 선택',
  'cloudDrive.nodeSelect.addNode': '스토리지 노드 추가',
  'cloudDrive.nodeSelect.deleteConfirm.title': '노드 삭제 확인',
  'cloudDrive.nodeSelect.deleteConfirm.content': '노드 "{nodeName}"을(를) 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다!',
  'cloudDrive.nodeSelect.deleteSuccess': '노드가 성공적으로 삭제되었습니다',
  'cloudDrive.nodeSelect.deleteFailed': '노드 삭제에 실패했습니다',
  
  // 노드 생성
  'cloudDrive.nodeCreate.title': '스토리지 노드 추가',
  'cloudDrive.nodeCreate.selectProvider': '클라우드 공급자 선택',
  'cloudDrive.nodeCreate.nodeName': '노드 이름',
  'cloudDrive.nodeCreate.nodeNamePlaceholder': '비워두면 기본 이름을 사용합니다',
  'cloudDrive.nodeCreate.nameMaxLength': '노드 이름은 50자를 초과할 수 없습니다',
  'cloudDrive.nodeCreate.noProviders': '사용 가능한 클라우드 공급자가 없습니다',
  'cloudDrive.nodeCreate.pingLatency': '지연 시간 {value} ms',
  'cloudDrive.nodeCreate.pingTesting': '지연 시간 테스트 중...',
  'cloudDrive.nodeCreate.pingFailed': '지연 시간 테스트 실패',
  'cloudDrive.nodeCreate.pingUnavailable': '지연 시간 테스트를 사용할 수 없음',
  'cloudDrive.nodeCreate.sortByLatency': '지연 시간으로 정렬',
  'cloudDrive.nodeCreate.selectRegion': '지역 선택',
  'cloudDrive.nodeCreate.selectedRegion': '선택된 지역',
  'cloudDrive.nodeCreate.noRegions': '사용 가능한 지역이 없습니다',
  'cloudDrive.nodeCreate.selectProviderPlaceholder': '클라우드 공급자를 선택하세요',
  'cloudDrive.nodeCreate.selectProviderRequired': '먼저 클라우드 공급자를 선택하세요',
  'cloudDrive.nodeCreate.selectRegionRequired': '먼저 지역을 선택하세요',
  'cloudDrive.nodeCreate.loadProvidersFailed': '클라우드 공급자 목록 로드 실패',
  'cloudDrive.nodeCreate.loadRegionsFailed': '지역 목록 로드 실패',
  'cloudDrive.nodeCreate.nodeType': '노드 유형',
  'cloudDrive.nodeCreate.nodeType.standard': '표준 스토리지',
  'cloudDrive.nodeCreate.nodeType.lowFreq': '저빈도 스토리지',
  'cloudDrive.nodeCreate.nodeType.archive': '아카이브 스토리지',
  'cloudDrive.nodeCreate.storageLimit': '스토리지 제한',
  'cloudDrive.nodeCreate.storageLimitRequired': '스토리지 제한을 입력하세요',
  'cloudDrive.nodeCreate.storageLimitMin': '스토리지 제한은 1GB보다 작을 수 없습니다',
  'cloudDrive.nodeCreate.storageLimitPlaceholder': '스토리지 제한을 입력하세요 (GB)',
  'cloudDrive.nodeCreate.success': '스토리지 노드가 성공적으로 생성되었습니다',
  'cloudDrive.nodeCreate.failed': '스토리지 노드 생성에 실패했습니다',
  
  // 노드 편집
  'cloudDrive.nodeEdit.title': '노드 편집',
  'cloudDrive.nodeEdit.name': '노드 이름',
  'cloudDrive.nodeEdit.nameRequired': '노드 이름을 입력하세요',
  'cloudDrive.nodeEdit.nameMaxLength': '노드 이름은 50자를 초과할 수 없습니다',
  
  // TextToImage page internationalization
  'create.prompt': '프롬프트',
  'create.prompt.placeholder': '예: 우주를 걷는 사이버펑크 고양이, 네온 배경, 고해상도...',
  'create.prompt.required': '프롬프트를 입력하세요',
  'create.prompt.generate': 'AI 프롬프트 생성',
  'create.prompt.enrich': 'AI 프롬프트 풍부화',
  'create.prompt.generate.success': '프롬프트가 성공적으로 생성되었습니다!',
  'create.prompt.generate.error': '프롬프트 생성에 실패했습니다. 다시 시도해주세요',
  'create.prompt.generate.empty': '프롬프트가 생성되지 않았습니다. 다시 시도해주세요',
  'create.prompt.restore': '복원',
  'create.prompt.restore.success': '원래 프롬프트로 복원되었습니다',
  'create.prompt.restore.tooltip': 'AI 생성/풍부화 이전의 프롬프트로 복원',
  'create.ratio': '화면 비율',
  'create.style': '예술 스타일',
  'create.batchSize': '생성 수량',
  'create.generate': '지금 생성',
  'create.negativePrompt.tooltip': '이미지에 포함하지 않을 요소',
  'create.negativePrompt.placeholder': '예: 흐림, 저품질, 변형된 손가락...',
  'create.generating': '생성 중...',
  'create.generating.waiting': 'AI가 생성 중입니다. 잠시만 기다려주세요...',
  'create.result.title': '생성 결과',
  'create.downloadAll': '모두 다운로드',
  'create.aspectRatio.1:1': '1:1 (정사각형)',
  'create.aspectRatio.16:9': '16:9 (가로)',
  'create.aspectRatio.9:16': '9:16 (세로)',
  'create.aspectRatio.21:9': '21:9 (시네마)',
  'create.aspectRatio.4:3': '4:3 (클래식)',
  'create.style.general': '일반',
  'create.style.anime': '애니메',
  'create.style.realistic': '사실적',
  'create.style.3d-render': '3D 렌더',
  'create.style.cyberpunk': '사이버펑크',
  'create.settings.loadFailed': '작성 유형 설정 로드 실패, 모든 옵션 표시',
  'create.settings.error': '설정 로드 실패, 모든 옵션 표시',
  'create.noAvailableTabs': '사용 가능한 작성 유형이 없습니다',
  'create.network.error.title': '네트워크 연결 오류',
  'create.network.error.description': '작성 유형 설정을 로드할 수 없습니다. 네트워크 연결을 확인하고 페이지를 새로고침하세요',
  'create.network.error.refresh': '페이지 새로고침',
  
  // TextToVideo page internationalization
  'create.prompt.video': '동영상 장면 설명 (Prompt)',
  'create.prompt.video.placeholder': '예: 달 표면에서 춤추는 우주비행사 개, 8K, 영화적 조명, 초현실주의.',
  'create.prompt.video.required': '동영상 장면 설명을 입력하세요',
  'create.generate.video': '지금 동영상 생성',
  'create.video.ratio': '동영상 종횡비',
  'create.video.camera': '카메라 모션',
  'create.video.duration': '동영상 길이 (초)',
  'create.video.format': '출력 형식',
  'create.cameraMotion.none': '움직임 없음 (None)',
  'create.cameraMotion.zoomIn': '줌 인 (Zoom In)',
  'create.cameraMotion.dollyOut': '돌리 아웃 (Dolly Out)',
  'create.cameraMotion.panLeft': '좌측 팬 (Pan Left)',
  'create.cameraMotion.tiltUp': '상향 틸트 (Tilt Up)',
  'create.cameraMotion.orbital': '360° 궤도',
  'create.negativePrompt.video.placeholder': '예: 워터마크, 깜빡임, 저해상도, 흐릿한 캐릭터...',
  'create.sora.thinking': 'Sora가 생각 중...',
  'create.video.analyzing': '이미지와 프롬프트 분석 중, AI가 생성 중...',
  'create.video.info': '길이: {duration}초 | 비율: {ratio}',
  'create.video.preview': '동영상 미리보기',
  'create.video.result': '최종 동영상 미리보기',
  'create.video.empty': '생성된 결과가 여기에 표시됩니다',
  'create.download': '동영상 다운로드',
  'create.duration.format': '{duration}초',
  'create.duration.4s': '4초',
  'create.duration.8s': '8초',
  'create.duration.15s': '15초',
  'create.estimated.price': '예상: {price}',
  'create.model.select': '모델 선택',
  'create.model.loading': '모델 로딩 중...',
  'create.model.loadFailed': '모델 목록 로드 실패',
  'create.model.family.select': '모델 패밀리 선택',
  'create.model.family.select.placeholder': '모델 패밀리를 선택하세요',
  'create.model.family.loadFailed': '모델 패밀리 목록 로드 실패',
  'create.style.select.placeholder': '예술 스타일을 선택하세요 (선택사항, 기본값은 패밀리 모델 사용)',
  'create.model.style.loadFailed': '스타일 모델 목록 로드 실패',
  'create.model.description': '모델 설명',
  'create.model.aspectResolution': '비율 해상도',
  'create.model.fps': '프레임 레이트',
  'create.model.features': '지원 기능',
  'create.model.feature.cameraMotion': '카메라 모션',
  'create.model.feature.img2video': '이미지에서 동영상',
  'create.model.feature.videoEdit': '동영상 편집',
  'create.model.price.perSecond': '/초',
  'create.model.detail': '세부정보',
  'create.history.title': '생성 기록',
  'create.history.refresh': '새로고침',
  'create.history.empty': '생성 기록이 없습니다',
  'create.history.total': '총 {total}개 기록',
  'create.history.status.queued': '대기 중',
  'create.history.status.processing': '처리 중',
  'create.history.status.success': '성공',
  'create.history.status.failed': '실패',
  'create.history.status.timeout': '시간 초과',
  'create.history.failed.noImage': '생성 실패',
  'create.history.downloadAll.start': '{count}개 이미지 다운로드 시작',
  'create.history.downloadAll.tooltip': '모든 {count}개 이미지 다운로드',
  'create.history.download.tooltip': '이미지 다운로드',
  'create.history.detail.tooltip': '세부 정보 보기',
  'create.history.noPrompt': '프롬프트 없음',
  'create.history.deleteConfirm.title': '삭제 확인',
  'create.history.deleteConfirm.content': '이 작업을 삭제하시겠습니까? 삭제 후에는 복구할 수 없습니다.',
  'create.history.deleteSuccess': '삭제되었습니다',
  'create.history.deleteFailed': '삭제 실패',
  'create.taskDetail.title': '작업 세부 정보',
  'create.taskDetail.loading': '로딩 중...',
  'create.taskDetail.loadFailed': '작업 세부 정보 로드 실패',
  'create.taskDetail.noData': '사용 가능한 데이터 없음',
  'create.taskDetail.basicInfo': '기본 정보',
  'create.taskDetail.model': '모델',
  'create.taskDetail.taskType': '작업 유형',
  'create.taskDetail.createTime': '생성 시간',
  'create.taskDetail.duration': '생성 기간',
  'create.taskDetail.prompt': '프롬프트',
  'create.taskDetail.error': '오류 메시지',
  'create.taskDetail.outputFiles': '출력 파일',
  'create.taskDetail.downloadAll': '모두 다운로드',
  'create.taskDetail.downloadAll.start': '{count}개 이미지 다운로드 시작',
  'create.taskDetail.modelInfo': '모델 정보',
  'create.taskDetail.defaultResolution': '기본 해상도',
  'create.taskDetail.maxResolution': '최대 해상도',
  'create.taskDetail.aspectRatios': '지원되는 종횡비',
  'create.taskDetail.formats': '지원되는 형식',
  'create.taskDetail.prompt.copied': '프롬프트가 복사되었습니다',
  'create.taskDetail.liked': '좋아요 완료',
  'create.taskDetail.like': '좋아요',
  'create.taskDetail.collected': '저장됨',
  'create.taskDetail.collect': '저장',
  'create.taskDetail.linkCopied': '링크가 복사되었습니다',
  'create.taskDetail.share': '공유',
  'create.taskDetail.outputs': '출력',
  'create.taskDetail.preview': '미리보기',
  'create.taskDetail.download': '다운로드',
  'create.taskDetail.generationFailed': '생성 실패',
  'create.taskDetail.generating': '생성 중...',
  'create.taskDetail.promptLabel': '프롬프트',
  'create.taskDetail.copy': '복사',
  'create.taskDetail.executionStats': '실행 통계',
  'create.taskDetail.creditsCost': '크레딧 비용',
  'create.taskDetail.modelSpecs': '모델 사양',
  'create.taskDetail.capabilities': '기능',
  'create.taskDetail.supportedRatios': '지원되는 종횡비',
  'create.taskDetail.dataError': '데이터 오류',
  'create.taskDetail.more': '더보기',
  'create.taskDetail.downloading': '다운로드 중...',
  'create.taskDetail.points': '포인트',
  'create.taskDetail.seconds': '초',
  'create.taskDetail.status.success': '성공',
  'create.taskDetail.status.failed': '실패',
  'create.taskDetail.status.processing': '처리 중',
  'create.taskDetail.status.queued': '대기 중',
  'create.taskDetail.status.generating': '생성 중',
  'create.taskDetail.durationLabel': '소요 시간',
  'create.taskDetail.taskParams': '작업 매개변수',
  'create.taskDetail.aspectRatio': '종횡비',
  'create.taskDetail.inputType': '입력 유형',
  'create.taskDetail.modelCode': '모델 코드',
  'create.taskDetail.regenerate': '다시 생성',
  'create.taskDetail.feature.developing': '기능 개발 중',
  'create.taskDetail.result': '생성 결과',
  'create.taskDetail.copyPrompt': '프롬프트 복사',
  'create.taskDetail.imageDimensions': '크기',
  'create.taskDetail.fileSize': '파일 크기',
  'create.taskDetail.loadingImageInfo': '이미지 정보 로딩 중...',
  'create.history.failed.noVideo': '생성 실패',
  'create.video.generate.cancelled.polling': '작업 폴링 취소됨',
  'create.video.generate.queued': '동영상 생성 작업이 제출되었습니다. 대기 중...',
  'create.video.generate.noUrl': '동영상 생성이 완료되었지만 동영상 URL을 찾을 수 없습니다',
  'create.video.status.checkFailed': '작업 상태 확인 실패',
  'create.video.generate.processing': '동영상 생성 작업이 제출되었습니다. 처리 중...',
  'create.video.taskQueue': '작업 대기열',
  'create.video.polling': '동영상을 생성 중입니다. 잠시만 기다려 주세요...',
  'create.video.ratio.invalid': '모델이 지원하는 동영상 종횡비를 선택하세요',
  'create.waitingTask.queue': '작업 대기열',
  'create.waitingTask.empty': '진행 중인 작업이 없습니다',
  'create.waitingTask.generating': '생성 중...',
  'create.waitingTask.queued': '대기 중',
  'create.waitingTask.cancel': '작업 취소',
  // HistorySection 새 국제화
  'create.history.copyPrompt': '프롬프트 복사',
  'create.history.download': '다운로드',
  'create.history.delete': '삭제',
  'create.history.generating': '생성 중...',
  'create.history.generationFailed': '생성 실패',
  'create.history.noPreview': '미리보기 없음',
  // ImageToVideo 새 국제화
  'create.i2v.fileType.error': '이미지 파일을 선택하세요',
  'create.i2v.fileSize.error': '이미지 파일 크기는 10MB를 초과할 수 없습니다',
  'create.i2v.imageSize.error': '이미지 높이는 최소 {minHeight}px 이상이어야 합니다. 현재 이미지 크기는 {width}x{height}px입니다',
  'create.i2v.fileRead.error': '이미지 읽기 실패',
  'create.i2v.replaceImage': '이미지 교체',
  'create.i2v.upload.supportedFormats': 'JPG, PNG, WebP, JFIF 지원',
  'create.i2v.upload.required': '참조 이미지를 업로드하세요',
  'create.i2v.upload': '참조 이미지 업로드 (시작 프레임)',
  'create.i2v.upload.click': '클릭하거나 드래그하여 업로드',
  'create.i2v.prompt.required': '동작 가이드 설명을 입력하세요',
  'create.i2v.uploading.image': '클라우드에 이미지 업로드 중...',
  'create.i2v.upload.success': '이미지 업로드 성공',
  'create.i2v.upload.failed': '이미지 업로드 실패, 다시 시도하세요',
  'create.i2v.original': '원본 (시작 프레임)',
  'create.i2v.result': '생성 비교',
  'create.i2v.empty': '생성 결과와 원본 이미지 비교가 여기에 표시됩니다',
  'create.generate.i2v': '동영상 생성 시작',
  'create.prompt.i2v.placeholder': '예: 이미지의 인물이 걷기 시작하고, 배경의 나뭇잎이 바람에 흔들리기...',
  'create.prompt.enhance.tooltip': 'AI로 프롬프트를 풍부하게 하여 설명을 더 자세하고 생생하게 만듭니다',
  'create.prompt.enhance': 'AI 강화',
  'create.prompt.enhance.empty': '먼저 기본 프롬프트를 입력하세요',
  'create.prompt.enhance.success': '프롬프트 강화 성공!',
  'create.prompt.enhance.empty.result': '강화된 프롬프트가 생성되지 않았습니다. 다시 시도하세요',
  'create.prompt.enhance.error': '프롬프트 강화 실패, 다시 시도하세요',
  'create.prompt.version.history': '버전 기록',
  'create.prompt.version.history.tooltip': '프롬프트 버전 기록 보기',
  // TaskDetailModal 새 국제화
  'create.taskDetail.unnamedTask': '이름 없는 작업',
  'create.taskDetail.prompt.title': '프롬프트',
  'create.taskDetail.tokenCost': '토큰 소비',
  'create.taskDetail.publish': '커뮤니티에 게시',
  'create.taskDetail.selectCover': '커버 선택',
  'create.taskDetail.selectChannel': '채널 선택',
  'create.taskDetail.selectChallenge': '챌린지 선택',
  'create.taskDetail.publishSuccess': '게시 성공',
  'create.taskDetail.loadChannelsFailed': '채널 로드 실패',
  'create.taskDetail.loadChallengesFailed': '챌린지 로드 실패',
  'create.taskDetail.publishFailed': '게시 실패',
  'create.taskDetail.daysLeft': '{days}일 남음',
  // ModelDetailModal 새 국제화
  'create.model.capability.t2v': 'T2V (텍스트에서 동영상)',
  'create.model.capability.img2video': '이미지에서 동영상',
  'create.model.capability.videoEdit': '동영상 편집',
  'create.model.capability.characterConsistency': '캐릭터 일관성',
  'create.model.capability.reference': '참조',
  'create.model.capability.cameraMotion': '카메라 모션',
  'create.model.aspectRatios': '종횡비',
  'create.model.resolution': '해상도',
  'create.model.resolution.default': '기본값',
  'create.model.resolution.max': '최대',
  'create.model.duration': '길이',
  'create.model.formats': '형식',
  'create.model.like': '좋아요',
  'create.model.liked': '좋아요함',
  'create.model.unliked': '좋아요 취소함',
  'create.model.favorite': '즐겨찾기',
  'create.model.favorited': '즐겨찾기 추가함',
  'create.model.unfavorited': '즐겨찾기 제거함',
  'create.model.share': '공유',
  'create.model.linkCopied': '링크 복사됨',
  'create.model.capabilities': '기능',
  'create.model.free': '무료',
  'create.model.tokenCost.display': '{count} token',
  // 기타 새 키
  'create.aspectRatio.portrait': '세로',
  'create.aspectRatio.landscape': '가로',
  'create.video.ratio.placeholder': '동영상 종횡비를 선택하세요',
  'create.video.format.placeholder': '출력 형식을 선택하세요',
  'create.video.style': '동영상 스타일',
  'create.video.style.tooltip': '동영상 생성 스타일 선택',
  'create.video.style.placeholder': '동영상 스타일을 선택하세요',
  'create.video.quality': '동영상 품질',
  'create.video.quality.tooltip': '동영상 생성 품질 선택',
  'create.video.quality.placeholder': '동영상 품질을 선택하세요',
  'create.duration.select.placeholder': '동영상 길이를 선택하세요',
  'create.model.select.placeholder': '먼저 모델을 선택하세요',
  'video.not.supported': '브라우저가 동영상 재생을 지원하지 않습니다.',
  // UnderDevelopment 국제화
  'underDevelopment.comingSoon': '곧 출시',
  'underDevelopment.title': '기능 개발 중',
  'underDevelopment.subtitle': '이 기능을 개발하기 위해 열심히 노력하고 있습니다. 기대해 주세요!',
  'underDevelopment.backHome': '홈으로 돌아가기',
  'underDevelopment.goBack': '뒤로 가기',
  // UserMenu 국제화
  'userMenu.email.notBound': '이메일 미등록',
  'userMenu.status.verified': '인증됨',
  'userMenu.status.guest': '게스트',
  'userMenu.level': '레벨',
  'userMenu.member.vip1': '일반 멤버',
  'userMenu.member.vip2': '실버 멤버',
  'userMenu.member.vip3': '골드 멤버',
  'userMenu.member.vip4': '다이아몬드 멤버',
  'userMenu.member.vip5': '최고급 멤버',
  'userMenu.recharge': '충전하기',
  'userMenu.community': '커뮤니티',
  'userMenu.group.account': '계정 설정',
  'userMenu.group.assets': '자산 및 주문',
  'userMenu.group.workspace': '작업 공간',
  'userMenu.group.support': '지원',
  'userMenu.item.profile': '프로필',
  'userMenu.item.settings': '설정',
  'userMenu.item.security': '보안',
  'userMenu.item.privacy': '개인정보',
  'userMenu.item.wallet': '내 지갑',
  'userMenu.item.subscription': '구독 관리',
  'userMenu.item.orders': '주문 내역',
  'userMenu.item.works': '내 작품',
  'userMenu.item.notifications': '알림',
  'userMenu.item.help': '도움말 센터',
  'userMenu.item.invite': '친구 초대',
  'userMenu.item.feedback': '피드백',
  'userMenu.item.about': '회사 소개',
  'userMenu.logout': '로그아웃',
  // Achievement System 국제화
  'achievement.category.all': '전체',
  'achievement.category.basic': '기본',
  'achievement.category.creation': '창작',
  'achievement.category.payment': '충전',
  'achievement.category.membership': '멤버십',
  'achievement.category.level': '레벨',
  'achievement.category.social': '소셜',
  'achievement.category.works': '작품',
  'achievement.level.current': '현재 레벨: {level}',
  'achievement.stats.unlocked': '해제됨',
  'achievement.stats.locked': '잠김',
  'achievement.stats.progress': '진행률',
  'achievement.stats.exp': '현재 경험치',
  // Recharge Agreement 국제화
  'rechargeAgreement.back': '돌아가기',
  'rechargeAgreement.title': '충전 서비스 약관',
  'rechargeAgreement.lastUpdated': '최종 업데이트: ',
  'rechargeAgreement.goRecharge': '충전하기',
  'rechargeAgreement.section1.title': '1. 약관 범위',
  'rechargeAgreement.section1.content1': '본 약관은 귀하와 플랫폼 간의 충전 서비스에 관한 법적 약관입니다. 충전 서비스를 사용하기 전에 본 약관의 전체 내용을 주의 깊게 읽어주세요. 본 약관의 어떤 내용에도 동의하지 않거나 관련 조항의 의미를 정확히 이해할 수 없는 경우 충전 작업을 수행하지 마세요.',
  'rechargeAgreement.section1.content2': '"동의"를 클릭하거나 충전 작업을 수행하면 본 약관의 전체 내용을 충분히 읽고 이해하며 동의한 것으로 간주됩니다.',
  'rechargeAgreement.section2.title': '2. 충전 안내',
  'rechargeAgreement.section2.subtitle1': '2.1 충전 방법',
  'rechargeAgreement.section2.content1': '플랫폼은 다음 충전 방법을 지원합니다:',
  'rechargeAgreement.section2.method1': '알리페이',
  'rechargeAgreement.section2.method2': '위챗페이',
  'rechargeAgreement.section2.method3': '은행 카드 (UnionPay, Visa, MasterCard)',
  'rechargeAgreement.section2.method4': 'USDT 암호화폐 (ERC20/TRC20)',
  'rechargeAgreement.section2.subtitle2': '2.2 충전 통화',
  'rechargeAgreement.section2.content2': '플랫폼은 다음 통화로 충전을 지원합니다: 위안화(CNY), 달러(USD), USDT. 다른 통화 간에 환율 변환이 있을 수 있으며, 구체적인 환율은 충전 시 실시간 환율을 따릅니다.',
  'rechargeAgreement.section2.subtitle3': '2.3 충전 한도',
  'rechargeAgreement.section2.limit1': '1회 최소 충전 금액: 1원 (또는 다른 통화의 등가액)',
  'rechargeAgreement.section2.limit2': '1회 최대 충전 금액: 50,000원 (또는 다른 통화의 등가액)',
  'rechargeAgreement.section2.limit3': '일일 누적 충전 한도: 100,000원 (또는 다른 통화의 등가액)',
  'rechargeAgreement.section2.note': '참고: 충전 한도는 결제 방법, 계정 등급 등의 요인에 따라 다를 수 있습니다. 자세한 내용은 충전 페이지를 참조하세요.',
  'rechargeAgreement.section3.title': '3. 충전 입금',
  'rechargeAgreement.section3.subtitle1': '3.1 입금 시간',
  'rechargeAgreement.section3.time1': '알리페이, 위챗페이: 실시간 입금',
  'rechargeAgreement.section3.time2': '은행 카드: 1-3 영업일 내 입금',
  'rechargeAgreement.section3.time3': 'USDT: 블록체인 확인 시간에 따라 일반적으로 10-30분 내 입금',
  'rechargeAgreement.section3.subtitle2': '3.2 예외 처리',
  'rechargeAgreement.section3.content1': '충전 후 제때 입금되지 않은 경우 결제 증빙을 보관하고 즉시 고객 서비스에 문의하세요. 플랫폼은 확인 후 가능한 한 빨리 충전 문제를 처리합니다.',
  'rechargeAgreement.section4.title': '4. 환불 정책',
  'rechargeAgreement.section4.important': '중요: 충전 성공 후 계정 잔액은 직접 환불을 지원하지 않습니다. 잔액은 플랫폼 내 서비스 소비에만 사용할 수 있습니다.',
  'rechargeAgreement.section4.subtitle1': '4.1 환불 조건',
  'rechargeAgreement.section4.content1': '다음 경우 환불을 신청할 수 있습니다:',
  'rechargeAgreement.section4.refund1': '플랫폼 시스템 오류로 인한 중복 충전',
  'rechargeAgreement.section4.refund2': '플랫폼 사유로 서비스를 정상적으로 사용할 수 없고 계정 잔액이 소비되지 않은 경우',
  'rechargeAgreement.section4.refund3': '플랫폼이 검토 후 동의한 기타 특수 상황',
  'rechargeAgreement.section4.subtitle2': '4.2 환불 프로세스',
  'rechargeAgreement.section4.process1': '환불 신청 제출 및 환불 사유 설명',
  'rechargeAgreement.section4.process2': '플랫폼 검토 (일반적으로 3-7 영업일)',
  'rechargeAgreement.section4.process3': '승인 후 환불은 원래 결제 계정으로 반환됩니다',
  'rechargeAgreement.section5.title': '5. 계정 보안',
  'rechargeAgreement.section5.content1': '귀하는 계정 정보 및 비밀번호를 적절히 보관할 책임이 있습니다. 귀하의 사유로 인해 계정이 도용되거나 비밀번호가 유출되어 발생한 손실에 대해 플랫폼은 책임을 지지 않습니다.',
  'rechargeAgreement.section5.content2': '계정에 이상이 발견되면 즉시 고객 서비스에 연락하고 비밀번호를 변경하세요. 플랫폼은 관련 문제 처리에 도움을 드립니다.',
  'rechargeAgreement.section6.title': '6. 면책 조항',
  'rechargeAgreement.section6.disclaimer1': '불가항력(자연재해, 전쟁, 정부 행위 등)으로 인한 서비스 중단에 대해 플랫폼은 책임을 지지 않습니다',
  'rechargeAgreement.section6.disclaimer2': '제3자 결제 플랫폼 오류로 인한 충전 문제에 대해 플랫폼은 처리에 도움을 드리지만 직접적인 책임을 지지 않습니다',
  'rechargeAgreement.section6.disclaimer3': '사용자가 본 약관 또는 관련 법률 및 규정을 위반하여 발생한 손실은 사용자 본인이 부담합니다',
  'rechargeAgreement.section7.title': '7. 약관 수정',
  'rechargeAgreement.section7.content1': '플랫폼은 사업 발전 필요에 따라 본 약관을 수정할 권리가 있습니다. 약관 수정 후 플랫폼의 눈에 띄는 위치에 공지됩니다. 귀하가 충전 서비스를 계속 사용하는 경우 수정된 약관을 수락한 것으로 간주됩니다.',
  'rechargeAgreement.section8.title': '8. 연락처',
  'rechargeAgreement.section8.content1': '본 약관에 대한 질문이 있거나 환불 신청, 충전 문제 처리가 필요한 경우 다음 방법으로 문의하세요:',
  'rechargeAgreement.section8.contact1': '고객 서비스 이메일: support@example.com',
  'rechargeAgreement.section8.contact2': '온라인 고객 서비스: 평일 9:00-18:00',
  'rechargeAgreement.section8.contact3': '도움말 센터: 자주 묻는 질문 보기',
  // 프로필 국제화
  'profile.editProfile': '프로필 편집',
  'profile.creditScore': '신용 점수',
  'profile.level': '레벨',
  'profile.balance': '잔액',
  'profile.tab.basic': '기본 정보',
  'profile.tab.account': '계정 자산',
  'profile.section.personal': '개인 정보',
  'profile.section.contact': '연락처',
  'profile.section.wallet': 'USDT 지갑',
  'profile.label.username': '사용자 이름',
  'profile.label.realName': '실명',
  'profile.label.accountStatus': '계정 상태',
  'profile.label.phone': '전화번호',
  'profile.label.email': '이메일',
  'profile.label.registerTime': '등록 시간',
  'profile.label.availableBalance': '사용 가능 잔액',
  'profile.label.frozenAmount': '동결 금액',
  'profile.value.notVerified': '미인증',
  'profile.value.notBound': '미등록',
  'profile.value.noAddress': 'TRC20 주소 없음',
  'profile.value.noDescription': '이 사람은 게으르고 아무것도 쓰지 않았습니다',
  'profile.status.normal': '정상',
  'profile.status.disabled': '비활성화',
  'profile.tooltip.verified': '실명 인증됨',
  'profile.tooltip.unverified': '실명 인증하기',
  'profile.banner.construction': '이 페이지는 현재 구축 중입니다...',
  'profile.modal.title': '프로필 편집',
  'profile.modal.cancel': '취소',
  'profile.modal.save': '변경 사항 저장',
  'profile.modal.avatarSection': '아바타 설정',
  'profile.modal.basicSection': '기본 정보',
  'profile.modal.contactSection': '연락처 정보',
  'profile.modal.changeAvatar': '아바타 변경',
  'profile.modal.avatarHint': 'JPG, PNG 형식 지원, 최대 2MB',
  'profile.modal.nickname': '닉네임',
  'profile.modal.nicknamePlaceholder': '닉네임을 입력하세요',
  'profile.modal.description': '자기소개',
  'profile.modal.descriptionPlaceholder': '한 마디로 자신을 소개하세요...',
  'profile.modal.phone': '전화번호',
  'profile.modal.email': '이메일',
  'profile.message.avatarSizeLimit': '이미지 크기는 2MB를 초과할 수 없습니다',
  'profile.message.avatarUploadSuccess': '아바타 업로드 성공',
  'profile.message.saveSuccess': '저장 성공',
  'profile.message.saveFailed': '저장 실패',
  'profile.message.uploadAvatarFailed': '아바타 업로드 실패',
  'profile.message.operationFailed': '작업 실패',
  'privacyPreferences.title': '개인정보 설정',
  'privacyPreferences.description': '개인정보 설정을 관리하고 데이터 수집 및 사용 방법을 제어합니다',
  'privacyPreferences.back': '뒤로',
  'privacyPreferences.save': '설정 저장',
  'privacyPreferences.saveSuccess': '개인정보 설정이 성공적으로 저장되었습니다',
  'privacyPreferences.saveError': '저장에 실패했습니다. 나중에 다시 시도해주세요',
  'privacyPreferences.required': '필수',
  'privacyPreferences.info': '개인정보 설정은 로컬에 저장되며 다음 방문 시 자동으로 적용됩니다. 로그인하면 설정을 클라우드에 동기화할 수 있습니다.',
  'privacyPreferences.info.loggedIn': '개인정보 설정은 계정에 저장되며 모든 기기에서 동기화됩니다. 언제든지 이 페이지로 돌아와 설정을 수정할 수 있습니다.',
  'cookieBanner.message': '로그인, 테마 및 기본 기능을 위해 쿠키와 로컬 스토리지를 사용합니다. 계속하면 개인정보 처리방침에 동의하는 것입니다.',
  'cookieBanner.acceptAll': '모두 동의',
  'cookieBanner.essentialOnly': '필수만',
  'cookieBanner.settings': '설정',
  'privacyPreferences.cookies.title': '쿠키 설정',
  'privacyPreferences.cookies.description': '쿠키는 더 나은 서비스 경험을 제공하는 데 도움이 됩니다. 특정 유형의 쿠키를 수락하거나 거부할 수 있습니다.',
  'privacyPreferences.cookies.essential': '필수 쿠키',
  'privacyPreferences.cookies.essential.desc': '이러한 쿠키는 웹사이트가 제대로 작동하는 데 필요하며 비활성화할 수 없습니다. 일반적으로 보안, 로그인 및 기본 기능에 사용됩니다.',
  'privacyPreferences.cookies.functional': '기능 쿠키',
  'privacyPreferences.cookies.functional.desc': '이러한 쿠키를 통해 웹사이트는 귀하의 선택을 기억하고 향상된 기능과 개인화된 경험을 제공할 수 있습니다.',
  'privacyPreferences.cookies.analytics': '분석 쿠키',
  'privacyPreferences.cookies.analytics.desc': '이러한 쿠키는 방문자가 웹사이트를 사용하는 방식을 이해하여 서비스를 개선하는 데 도움이 됩니다.',
  'privacyPreferences.cookies.marketing': '마케팅 쿠키',
  'privacyPreferences.cookies.marketing.desc': '이러한 쿠키는 귀하의 브라우징 활동을 추적하여 관련 광고 및 콘텐츠를 표시하는 데 사용됩니다.',
  'privacyPreferences.data.title': '데이터 수집 설정',
  'privacyPreferences.data.description': '서비스 경험을 개선하기 위해 데이터를 수집하고 사용하는 방법을 제어합니다.',
  'privacyPreferences.data.collection': '데이터 수집',
  'privacyPreferences.data.collection.desc': '서비스를 제공하고 개선하기 위해 필요한 사용 데이터를 수집하는 것을 허용합니다.',
  'privacyPreferences.data.analytics': '데이터 분석',
  'privacyPreferences.data.analytics.desc': '서비스 성능과 사용자 경험을 최적화하기 위해 사용 패턴을 분석하는 것을 허용합니다.',
  'privacyPreferences.data.personalization': '개인화',
  'privacyPreferences.data.personalization.desc': '귀하의 선호도와 사용 습관에 따라 개인화된 콘텐츠와 추천을 제공하는 것을 허용합니다.',
  'privacyPreferences.marketing.title': '마케팅 설정',
  'privacyPreferences.marketing.description': '수신하려는 마케팅 정보 유형을 선택합니다.',
  'privacyPreferences.marketing.emails': '마케팅 이메일',
  'privacyPreferences.marketing.emails.desc': '제품 업데이트, 프로모션 및 특별 혜택에 대한 이메일 알림을 받습니다.',
  'privacyPreferences.marketing.sms': '마케팅 SMS',
  'privacyPreferences.marketing.sms.desc': '중요한 업데이트 및 프로모션에 대한 SMS 알림을 받습니다.',
  'privacyPreferences.marketing.push': '푸시 알림',
  'privacyPreferences.marketing.push.desc': '제품 업데이트 및 중요한 메시지를 포함한 브라우저 푸시 알림을 받습니다.',
  'privacyPreferences.thirdParty.title': '제3자 데이터 공유',
  'privacyPreferences.thirdParty.description': '제3자 서비스 제공업체와 데이터를 공유하는 것을 허용할지 여부를 제어합니다.',
  'privacyPreferences.thirdParty.sharing': '제3자 데이터 공유',
  'privacyPreferences.thirdParty.sharing.desc': '서비스를 개선하기 위해 신뢰할 수 있는 제3자 서비스 제공업체와 익명화된 사용 데이터를 공유하는 것을 허용합니다.',
  'works.title': '내 작품',
  'works.description': '생성한 모든 작품을 관리하고 보기',
  'works.refresh': '새로고침',
  'works.stats.total': '전체 작품',
  'works.stats.images': '이미지',
  'works.stats.videos': '비디오',
  'works.stats.audios': '오디오',
  'works.stats.favorites': '즐겨찾기',
  'works.search.placeholder': '작품 검색...',
  'works.filter.all': '모든 유형',
  'works.filter.image': '이미지',
  'works.filter.video': '비디오',
  'works.filter.audio': '오디오',
  'works.date.start': '시작 날짜',
  'works.date.end': '종료 날짜',
  'works.sort.date': '날짜순',
  'works.sort.name': '이름순',
  'works.sort.size': '크기순',
  'works.sort.asc': '오름차순',
  'works.sort.desc': '내림차순',
  'works.view.grid': '그리드',
  'works.view.list': '목록',
  'works.type.video': '비디오',
  'works.type.image': '이미지',
  'works.type.audio': '오디오',
  'works.preview': '미리보기',
  'works.download': '다운로드',
  'works.share': '공유',
  'works.delete': '삭제',
  'works.deleteConfirm': '이 작품을 삭제하시겠습니까?',
  'works.loadError': '작품 로드 실패, 나중에 다시 시도해주세요',
  'works.favoriteUpdated': '즐겨찾기 상태가 업데이트되었습니다',
  'works.favoriteError': '즐겨찾기 업데이트 실패',
  'works.downloading': '다운로드 중...',
  'works.sharing': '공유 링크 생성 중...',
  'works.deleted': '작품이 삭제되었습니다',
  'works.deleteError': '삭제 실패, 나중에 다시 시도해주세요',
  'works.empty.title': '작품이 없습니다',
  'works.empty.description': '첫 작품을 만들어보세요!',
  'works.empty.action': '작성하기',
  'works.pagination.total': '총 {total}개, {start}-{end}개 표시',
  
  // 개인정보 보호정책
  'privacyPolicy.title': '개인정보 보호정책',
  'privacyPolicy.lastUpdated': '최종 업데이트: {date}',
  'privacyPolicy.intro1': '본 개인정보 보호정책은 AIMATEX 플랫폼(이하 "당사" 또는 "본 플랫폼")이 귀하가 당사의 서비스를 사용할 때 귀하의 개인정보를 수집, 사용, 저장 및 보호하는 방법과 귀하의 개인정보 권리에 대해 설명합니다. 당사는 귀하의 개인정보 보호를 매우 중요하게 생각하며, 본 개인정보 보호정책을 주의 깊게 읽어주시기 바랍니다.',
  'privacyPolicy.intro2': '당사의 서비스를 사용함으로써 귀하는 본 개인정보 보호정책에 동의하는 것으로 간주됩니다. 본 개인정보 보호정책의 어떤 내용에도 동의하지 않는 경우, 당사의 서비스를 사용하지 마십시오.',
  'privacyPolicy.section1.title': 'I. 당사가 수집하는 정보',
  'privacyPolicy.section1.1.title': '1.1 귀하가 제공하는 정보',
  'privacyPolicy.section1.1.intro': '본 서비스를 사용할 때 다음 정보를 제공해야 할 수 있습니다:',
  'privacyPolicy.section1.1.item1.label': '계정 정보',
  'privacyPolicy.section1.1.item1.desc': '사용자 이름, 이메일 주소, 비밀번호, 전화번호 등',
  'privacyPolicy.section1.1.item2.label': '프로필 정보',
  'privacyPolicy.section1.1.item2.desc': '아바타, 닉네임, 자기소개 등(선택사항)',
  'privacyPolicy.section1.1.item3.label': '결제 정보',
  'privacyPolicy.section1.1.item3.desc': '결제 방법, 청구 주소 등(결제 처리용)',
  'privacyPolicy.section1.1.item4.label': '생성 콘텐츠',
  'privacyPolicy.section1.1.item4.desc': '업로드한 텍스트 프롬프트, 참조 이미지, 생성된 비디오, 음악, 이미지, 3D 모델 등',
  'privacyPolicy.section1.2.title': '1.2 자동으로 수집되는 정보',
  'privacyPolicy.section1.2.intro': '본 서비스를 사용할 때 당사는 다음 정보를 자동으로 수집할 수 있습니다:',
  'privacyPolicy.section1.2.item1.label': '기기 정보',
  'privacyPolicy.section1.2.item1.desc': '기기 유형, 운영 체제, 브라우저 유형 및 버전, 기기 식별자 등',
  'privacyPolicy.section1.2.item2.label': '사용 데이터',
  'privacyPolicy.section1.2.item2.desc': '접근 시간, 접근 페이지, 사용 기능, 작업 기록 등',
  'privacyPolicy.section1.2.item3.label': '네트워크 정보',
  'privacyPolicy.section1.2.item3.desc': 'IP 주소, 네트워크 유형, 네트워크 사업자 등',
  'privacyPolicy.section1.2.item4.label': '로그 정보',
  'privacyPolicy.section1.2.item4.desc': '오류 로그, 성능 데이터 등',
  'privacyPolicy.section1.3.title': '1.3 쿠키 및 유사 기술',
  'privacyPolicy.section1.3.intro': '당사는 쿠키 및 유사 기술을 다음 목적으로 사용합니다:',
  'privacyPolicy.section1.3.item1': '로그인 상태 유지',
  'privacyPolicy.section1.3.item2': '언어, 테마 등 선호 설정 기억',
  'privacyPolicy.section1.3.item3': '서비스 사용 상황 분석, 서비스 품질 개선',
  'privacyPolicy.section1.3.item4': '개인화된 경험 제공',
  'privacyPolicy.section1.3.note': '브라우저 설정에서 쿠키를 거부할 수 있지만, 일부 기능 사용에 영향을 줄 수 있습니다.',
  'privacyPolicy.section2.title': 'II. 정보 사용 목적',
  'privacyPolicy.section2.intro': '당사는 귀하의 정보를 다음 목적으로 수집 및 사용합니다:',
  'privacyPolicy.section2.item1.label': '서비스 제공',
  'privacyPolicy.section2.item1.desc': '콘텐츠 생성 요청(비디오, 음악, 이미지, 3D 모델 등) 처리, 계정 및 작품 관리 등',
  'privacyPolicy.section2.item2.label': '서비스 개선',
  'privacyPolicy.section2.item2.desc': '사용 상황 분석, 서비스 성능 및 사용자 경험 최적화',
  'privacyPolicy.section2.item3.label': '계정 관리',
  'privacyPolicy.section2.item3.desc': '신원 확인, 결제 처리, 알림 전송 등',
  'privacyPolicy.section2.item4.label': '보안',
  'privacyPolicy.section2.item4.desc': '사기, 남용, 보안 위협 감지 및 방지 등',
  'privacyPolicy.section2.item5.label': '고객 지원',
  'privacyPolicy.section2.item5.desc': '문의 응답, 불만 및 피드백 처리 등',
  'privacyPolicy.section2.item6.label': '법적 준수',
  'privacyPolicy.section2.item6.desc': '법률 및 규정 요구사항 준수, 법 집행 기관 조사 협조 등',
  'privacyPolicy.section3.title': 'III. 정보 공유 및 공개',
  'privacyPolicy.section3.1.title': '3.1 당사는 귀하의 개인정보를 판매하지 않습니다',
  'privacyPolicy.section3.1.content': '당사는 제3자에게 개인정보를 판매, 임대 또는 기타 방식으로 거래하지 않습니다.',
  'privacyPolicy.section3.2.title': '3.2 서비스 제공업체',
  'privacyPolicy.section3.2.intro': '당사는 다음 유형의 서비스 제공업체와 정보를 공유할 수 있습니다:',
  'privacyPolicy.section3.2.item1.label': '클라우드 서비스 제공업체',
  'privacyPolicy.section3.2.item1.desc': '데이터 저장 및 처리용',
  'privacyPolicy.section3.2.item2.label': '결제 서비스 제공업체',
  'privacyPolicy.section3.2.item2.desc': '결제 거래 처리용',
  'privacyPolicy.section3.2.item3.label': '분석 서비스 제공업체',
  'privacyPolicy.section3.2.item3.desc': '서비스 사용 상황 분석용',
  'privacyPolicy.section3.2.item4.label': '고객 지원 서비스 제공업체',
  'privacyPolicy.section3.2.item4.desc': '고객 지원 제공용',
  'privacyPolicy.section3.2.note': '이러한 서비스 제공업체는 당사에 서비스를 제공하는 목적으로만 정보를 사용할 수 있으며, 다른 목적으로는 사용할 수 없습니다.',
  'privacyPolicy.section3.3.title': '3.3 법적 요구사항',
  'privacyPolicy.section3.3.intro': '다음 상황에서 당사는 귀하의 정보를 공개할 수 있습니다:',
  'privacyPolicy.section3.3.item1': '법률, 규정, 법원 명령 또는 정부 요구사항 준수',
  'privacyPolicy.section3.3.item2': '당사의 권리, 재산 또는 안전 보호',
  'privacyPolicy.section3.3.item3': '가능한 불법 활동 방지 또는 조사',
  'privacyPolicy.section3.3.item4': '사용자 또는 대중의 안전 보호',
  'privacyPolicy.section3.4.title': '3.4 사업 양도',
  'privacyPolicy.section3.4.content': '합병, 인수 또는 자산 양도가 발생하는 경우, 귀하의 정보가 이전될 수 있습니다. 당사는 이전 전에 귀하에게 알려드립니다.',
  'privacyPolicy.section4.title': 'IV. 정보 저장 및 보안',
  'privacyPolicy.section4.1.title': '4.1 저장 위치',
  'privacyPolicy.section4.1.content': '귀하의 정보는 중화인민공화국 내 또는 외부의 서버에 저장될 수 있습니다. 당사는 정보 보안을 보장하기 위한 적절한 조치를 취합니다.',
  'privacyPolicy.section4.2.title': '4.2 저장 기간',
  'privacyPolicy.section4.2.intro': '당사는 필요한 기간 동안만 귀하의 정보를 보관합니다:',
  'privacyPolicy.section4.2.item1': '계정 정보: 계정 유지 기간 및 삭제 후 일정 기간',
  'privacyPolicy.section4.2.item2': '생성 콘텐츠: 귀하의 설정 또는 법적 요구사항에 따라 보관',
  'privacyPolicy.section4.2.item3': '사용 데이터: 일반적으로 분석 및 서비스 개선을 위해 짧은 기간 보관',
  'privacyPolicy.section4.3.title': '4.3 보안 조치',
  'privacyPolicy.section4.3.intro': '당사는 귀하의 정보를 보호하기 위해 다음 보안 조치를 취합니다:',
  'privacyPolicy.section4.3.item1': '암호화된 전송 및 저장',
  'privacyPolicy.section4.3.item2': '접근 제어 및 인증',
  'privacyPolicy.section4.3.item3': '정기적인 보안 감사 및 취약점 스캔',
  'privacyPolicy.section4.3.item4': '직원 교육 및 기밀 유지 계약',
  'privacyPolicy.section4.3.note': '어떤 보안 조치도 100% 안전하지 않습니다. 당사는 정보의 절대적 보안을 보장할 수 없습니다.',
  'privacyPolicy.section5.title': 'V. 귀하의 권리',
  'privacyPolicy.section5.intro': '적용 가능한 법률 및 규정에 따라 귀하는 다음 권리를 가집니다:',
  'privacyPolicy.section5.item1.label': '접근권',
  'privacyPolicy.section5.item1.desc': '당사가 보유한 귀하의 개인정보 조회',
  'privacyPolicy.section5.item2.label': '정정권',
  'privacyPolicy.section5.item2.desc': '부정확하거나 불완전한 정보 정정',
  'privacyPolicy.section5.item3.label': '삭제권',
  'privacyPolicy.section5.item3.desc': '귀하의 개인정보 삭제 요청(법적으로 보관이 요구되는 경우 제외)',
  'privacyPolicy.section5.item4.label': '동의 철회권',
  'privacyPolicy.section5.item4.desc': '정보 처리에 대한 동의 철회',
  'privacyPolicy.section5.item5.label': '데이터 이동권',
  'privacyPolicy.section5.item5.desc': '귀하의 개인정보 사본 획득',
  'privacyPolicy.section5.item6.label': '이의제기권',
  'privacyPolicy.section5.item6.desc': '특정 정보 처리 활동에 이의 제기',
  'privacyPolicy.section5.note': '위 권리를 행사하려면 본 개인정보 보호정책 끝부분의 연락처를 통해 당사에 연락하시기 바랍니다.',
  'privacyPolicy.section6.title': 'VI. 미성년자 보호',
  'privacyPolicy.section6.content1': '본 서비스는 주로 18세 이상의 사용자를 대상으로 합니다. 18세 미만인 경우, 보호자의 동의와 지도 하에 본 서비스를 사용하시기 바랍니다.',
  'privacyPolicy.section6.content2': '18세 미만 사용자의 개인정보를 수집했고 보호자 동의를 받지 않은 것으로 확인되면, 당사는 관련 정보를 가능한 한 빨리 삭제합니다.',
  'privacyPolicy.section7.title': 'VII. 제3자 링크',
  'privacyPolicy.section7.content': '본 서비스에는 제3자 웹사이트로의 링크가 포함될 수 있습니다. 당사는 이러한 제3자 웹사이트의 개인정보 보호 관행에 대해 책임을 지지 않습니다. 이러한 웹사이트를 방문할 때는 해당 개인정보 보호정책을 확인하시기 바랍니다.',
  'privacyPolicy.section8.title': 'VIII. 개인정보 보호정책 변경',
  'privacyPolicy.section8.content1': '당사는 본 개인정보 보호정책을 수시로 업데이트할 수 있습니다. 중요한 변경사항은 발효 최소 30일 전에 알려드립니다. 서비스를 계속 사용하는 것은 업데이트된 개인정보 보호정책에 동의하는 것으로 간주됩니다.',
  'privacyPolicy.section8.content2': '당사는 본 페이지 상단에서 "최종 업데이트" 날짜를 업데이트하고, 이메일 또는 앱 내 알림을 통해 중요한 변경사항을 알려드립니다.',
  'privacyPolicy.section9.title': 'IX. 문의하기',
  'privacyPolicy.section9.intro': '본 개인정보 보호정책에 대한 질문, 의견 또는 불만이 있으시면 다음 방법으로 당사에 연락하시기 바랍니다:',
  'privacyPolicy.section9.email': '이메일: {email}',
  'privacyPolicy.section9.hours': '고객 서비스 시간: 평일 9:00-18:00',
  'privacyPolicy.section9.response': '당사는 합리적인 시간 내에 귀하의 요청에 응답하겠습니다.',
  
  // 이용약관
  'termsOfService.title': '이용약관',
  'termsOfService.lastUpdated': '최종 업데이트: {date}',
  'termsOfService.intro': '당사의 서비스를 사용하기 전에 본 이용약관을 주의 깊게 읽어주시기 바랍니다. AIMATEX 플랫폼(이하 "본 플랫폼" 또는 "서비스")에 접근하거나 사용함으로써 귀하는 본 이용약관에 구속되는 것에 동의하는 것으로 간주됩니다. 본 이용약관의 어떤 부분에도 동의하지 않는 경우, 당사의 서비스를 사용하지 마십시오.',
  'termsOfService.section1.title': 'I. 정의 및 해석',
  'termsOfService.section1.1.title': '1.1 정의',
  'termsOfService.section1.1.intro': '본 이용약관에서 문맥상 달리 명시되지 않는 한, 다음 용어는 다음 의미를 가집니다:',
  'termsOfService.section1.1.item1.label': '"플랫폼" 또는 "본 플랫폼"',
  'termsOfService.section1.1.item1.desc': 'AIMATEX 비디오 생성 서비스 플랫폼을 의미하며, 웹사이트, 모바일 애플리케이션 및 관련 서비스를 포함하되 이에 국한되지 않습니다.',
  'termsOfService.section1.1.item2.label': '"당사", "우리", "회사"',
  'termsOfService.section1.1.item2.desc': 'AIMATEX 플랫폼의 운영자, 즉 ProTX Team을 의미합니다.',
  'termsOfService.section1.1.item3.label': '"귀하", "사용자"',
  'termsOfService.section1.1.item3.desc': '본 서비스에 접근하거나 사용하는 개인, 회사 또는 기타 법적 실체를 의미합니다.',
  'termsOfService.section1.1.item4.label': '"서비스"',
  'termsOfService.section1.1.item4.desc': '본 플랫폼이 제공하는 모든 기능 및 서비스를 의미하며, AI 비디오, 음악, 이미지, 3D 모델 등 다양한 콘텐츠 생성, 모델 선택, 작품 관리, 사용자 계정 관리 등을 포함하되 이에 국한되지 않습니다.',
  'termsOfService.section1.1.item5.label': '"콘텐츠"',
  'termsOfService.section1.1.item5.desc': '사용자가 본 플랫폼을 통해 업로드, 생성, 생성 또는 공유하는 모든 텍스트, 이미지, 비디오, 오디오 등의 자료를 의미합니다.',
  'termsOfService.section1.1.item6.label': '"생성 콘텐츠"',
  'termsOfService.section1.1.item6.desc': '사용자가 본 플랫폼의 AI 모델을 사용하여 생성한 비디오, 음악, 이미지, 3D 모델 등 다양한 작품을 의미합니다.',
  'termsOfService.section1.1.item7.label': '"계정"',
  'termsOfService.section1.1.item7.desc': '사용자가 본 플랫폼에 등록한 사용자 계정을 의미합니다.',
  'termsOfService.section2.title': 'II. 서비스 설명',
  'termsOfService.section2.1.title': '2.1 서비스 내용',
  'termsOfService.section2.1.intro': '본 플랫폼은 포괄적인 AI 콘텐츠 생성 서비스를 제공하며, 다음을 포함하되 이에 국한되지 않습니다:',
  'termsOfService.section2.1.item1': '텍스트-미디어 생성(비디오, 음악, 이미지, 3D 모델 등)(Text-to-Media)',
  'termsOfService.section2.1.item2': '이미지-미디어 생성(비디오, 3D 모델 등)(Image-to-Media)',
  'termsOfService.section2.1.item3': '다양한 생성 작품의 관리 및 표시',
  'termsOfService.section2.1.item4': '모델 선택 및 관리',
  'termsOfService.section2.1.item5': '사용자 계정 및 개인 센터',
  'termsOfService.section2.1.item6': '구독 및 결제 서비스',
  'termsOfService.section2.2.title': '2.2 서비스 변경',
  'termsOfService.section2.2.content': '당사는 사전 통지 없이 언제든지 서비스의 일부 또는 전부를 수정, 일시 중지 또는 종료할 권리를 보유합니다. 당사는 서비스 변경으로 인한 모든 손실에 대해 책임을 지지 않습니다.',
  'termsOfService.section3.title': 'III. 사용자 계정',
  'termsOfService.section3.1.title': '3.1 계정 등록',
  'termsOfService.section3.1.intro': '본 서비스를 사용하려면 계정 등록이 필요합니다. 등록 시 귀하는 다음에 동의하는 것으로 간주됩니다:',
  'termsOfService.section3.1.item1': '진실하고 정확하며 완전한 등록 정보 제공',
  'termsOfService.section3.1.item2': '등록 정보를 적시에 업데이트하여 진실하고 정확하며 완전한 상태로 유지',
  'termsOfService.section3.1.item3': '계정 하의 모든 활동에 대한 책임',
  'termsOfService.section3.1.item4': '계정 비밀번호를 적절히 보관하고 계정을 타인에게 양도, 판매 또는 대여하지 않음',
  'termsOfService.section3.2.title': '3.2 연령 제한',
  'termsOfService.section3.2.content': '본 서비스를 사용하려면 만 18세 이상이어야 합니다. 만 18세 미만인 경우, 보호자의 동의와 지도 하에 본 서비스를 사용하시기 바랍니다.',
  'termsOfService.section3.3.title': '3.3 계정 보안',
  'termsOfService.section3.3.content': '귀하는 계정의 보안을 유지할 책임이 있습니다. 계정이 도용되었거나 보안 취약점이 발견되면 즉시 당사에 알려주시기 바랍니다. 당사는 귀하가 계정 정보를 적절히 보호하지 않아 발생한 손실에 대해 책임을 지지 않습니다.',
  'termsOfService.section4.title': 'IV. 사용 규칙',
  'termsOfService.section4.1.title': '4.1 금지 행위',
  'termsOfService.section4.1.intro': '본 서비스를 사용할 때 다음을 수행해서는 안 됩니다:',
  'termsOfService.section4.1.item1': '불법적, 유해, 위협적, 모욕적, 괴롭힘, 비방, 저속, 음란, 타인의 개인정보 또는 지적재산권을 침해하는 콘텐츠 생성, 업로드 또는 공유',
  'termsOfService.section4.1.item2': '거짓 정보, 오해의 소지가 있는 콘텐츠 또는 악의적인 콘텐츠 생성 또는 확산',
  'termsOfService.section4.1.item3': '본 서비스를 사용하여 상업적 사기, 돈세탁 또는 기타 불법 활동 수행',
  'termsOfService.section4.1.item4': '자동화 도구, 크롤러, 바이러스 등을 사용하여 본 플랫폼의 정상 작동을 방해하거나 파괴',
  'termsOfService.section4.1.item5': '본 플랫폼의 시스템, 데이터 또는 계정에 무단 접근',
  'termsOfService.section4.1.item6': '본 플랫폼의 일부를 복제, 수정, 배포, 판매 또는 임대',
  'termsOfService.section4.1.item7': '본 플랫폼의 소프트웨어를 역공학, 역컴파일 또는 역어셈블',
  'termsOfService.section4.2.title': '4.2 콘텐츠 책임',
  'termsOfService.section4.2.content': '귀하는 본 플랫폼을 통해 생성, 업로드 또는 공유하는 모든 콘텐츠에 대해 전적인 책임을 집니다. 당사는 사용자 생성 콘텐츠를 사전에 검토하지 않지만, 위반 콘텐츠를 언제든지 삭제할 권리를 보유합니다.',
  'termsOfService.section5.title': 'V. 지적재산권',
  'termsOfService.section5.1.title': '5.1 플랫폼 지적재산권',
  'termsOfService.section5.1.content': '본 플랫폼의 모든 지적재산권(상표, 특허, 저작권, 영업 비밀 등을 포함하되 이에 국한되지 않음)은 당사 또는 관련 권리자에게 귀속됩니다. 무단 사용할 수 없습니다.',
  'termsOfService.section5.2.title': '5.2 사용자 생성 콘텐츠',
  'termsOfService.section5.2.content': '귀하가 본 플랫폼을 통해 생성하는 콘텐츠의 지적재산권은 귀하에게 귀속됩니다. 그러나 귀하는 당사에 비독점적, 전 세계적, 무료, 재라이선스 가능한 권리를 부여하여 서비스를 제공하고 개선하기 위해 귀하의 콘텐츠를 사용, 표시 및 배포할 수 있도록 합니다.',
  'termsOfService.section5.3.title': '5.3 AI 모델',
  'termsOfService.section5.3.content': '본 플랫폼에서 사용하는 AI 모델( Sora 모델 포함)의 지적재산권은 해당 개발자에게 귀속됩니다. 귀하는 이러한 모델을 복제, 수정 또는 배포할 수 없습니다.',
  'termsOfService.section6.title': 'VI. 유료 서비스',
  'termsOfService.section6.1.title': '6.1 결제 모델',
  'termsOfService.section6.1.content': '본 플랫폼은 구독 및 사용량 기반 결제 두 가지 모델을 제공합니다. 구체적인 가격 및 과금 방식은 플랫폼 공지에 따릅니다.',
  'termsOfService.section6.2.title': '6.2 결제',
  'termsOfService.section6.2.content': '귀하는 플랫폼이 공지한 가격에 따라 서비스 요금을 지불하는 것에 동의합니다. 모든 요금은 인민폐 또는 플랫폼이 지원하는 기타 통화로 계산됩니다. 결제가 성공한 후, 법률에 달리 규정되어 있지 않거나 당사가 달리 약속하지 않는 한 요금은 환불되지 않습니다.',
  'termsOfService.section6.3.title': '6.3 환불 정책',
  'termsOfService.section6.3.content': '법률에 달리 규정되어 있지 않거나 당사가 달리 약속하지 않는 한, 지불된 요금은 환불되지 않습니다. 플랫폼의 사유로 서비스를 정상적으로 사용할 수 없는 경우, 당사는 실제 상황에 따라 환불 또는 보상을 제공합니다.',
  'termsOfService.section7.title': 'VII. 서비스 가용성',
  'termsOfService.section7.1.title': '7.1 서비스 중단',
  'termsOfService.section7.1.intro': '당사는 다음 이유로 인한 서비스 중단에 대해 책임을 지지 않습니다:',
  'termsOfService.section7.1.item1': '시스템 유지보수, 업그레이드 또는 장애',
  'termsOfService.section7.1.item2': '불가항력 요인(자연재해, 전쟁, 파업 등)',
  'termsOfService.section7.1.item3': '제3자 서비스 제공업체의 문제',
  'termsOfService.section7.1.item4': '네트워크 장애 또는 사용자 기기 문제',
  'termsOfService.section7.2.title': '7.2 서비스 보장',
  'termsOfService.section7.2.content': '당사는 서비스의 안정성과 가용성을 보장하기 위해 노력하지만, 서비스가 중단되지 않고 오류가 없으며 완전히 안전하다는 것을 보장하지는 않습니다. 서비스는 "현재 상태" 및 "사용 가능" 기준으로 제공되며, 명시적 또는 묵시적 보장을 제공하지 않습니다.',
  'termsOfService.section8.title': 'VIII. 개인정보 보호',
  'termsOfService.section8.content': '당사는 귀하의 개인정보 보호를 중요하게 생각합니다. 당사가 귀하의 개인정보를 수집, 사용 및 보호하는 방법에 대한 자세한 내용은 당사의 "개인정보 보호정책"을 참조하시기 바랍니다. 본 서비스를 사용함으로써 귀하는 당사의 개인정보 보호정책에 동의하는 것으로 간주됩니다.',
  'termsOfService.section9.title': 'IX. 책임 제한',
  'termsOfService.section9.1.title': '9.1 책임 범위',
  'termsOfService.section9.1.intro': '법률이 허용하는 최대 범위 내에서, 당사는 본 서비스의 사용 또는 사용 불가로 인해 발생하는 모든 직접적, 간접적, 우발적, 특별 또는 결과적 손해에 대해 책임을 지지 않으며, 다음을 포함하되 이에 국한되지 않습니다:',
  'termsOfService.section9.1.item1': '이익 손실, 데이터 손실 또는 기타 경제적 손실',
  'termsOfService.section9.1.item2': '사업 중단',
  'termsOfService.section9.1.item3': '신체 상해 또는 재산 손실',
  'termsOfService.section9.1.item4': '개인정보 유출',
  'termsOfService.section9.2.title': '9.2 책임 상한',
  'termsOfService.section9.2.content': '당사의 총 책임은 귀하가 과거 12개월 동안 본 서비스를 통해 실제로 지불한 요금 총액 또는 100달러(더 높은 금액)를 초과하지 않습니다.',
  'termsOfService.section10.title': 'X. 서비스 종료',
  'termsOfService.section10.1.title': '10.1 사용자 종료',
  'termsOfService.section10.1.content': '귀하는 언제든지 본 서비스 사용을 중지하고 계정을 취소할 수 있습니다.',
  'termsOfService.section10.2.title': '10.2 플랫폼 종료',
  'termsOfService.section10.2.intro': '당사는 다음 상황에서 귀하의 계정 및 서비스를 즉시 종료하거나 일시 중지할 권리가 있습니다:',
  'termsOfService.section10.2.item1': '귀하가 본 이용약관을 위반한 경우',
  'termsOfService.section10.2.item2': '귀하가 불법 활동을 수행한 경우',
  'termsOfService.section10.2.item3': '귀하의 계정이 장기간 사용되지 않은 경우',
  'termsOfService.section10.2.item4': '법적 또는 규제 요구사항',
  'termsOfService.section10.2.note': '서비스 종료 후, 법률에 달리 규정되어 있지 않으면 귀하는 계정 및 생성된 콘텐츠에 접근할 수 없습니다.',
  'termsOfService.section11.title': 'XI. 분쟁 해결',
  'termsOfService.section11.1.title': '11.1 협상 해결',
  'termsOfService.section11.1.content': '분쟁이 발생하면 양측은 먼저 우호적 협상을 통해 해결해야 합니다.',
  'termsOfService.section11.2.title': '11.2 적용 법률',
  'termsOfService.section11.2.content': '본 이용약관은 중화인민공화국 법률의 적용을 받습니다. 양측이 협상을 통해 분쟁을 해결할 수 없는 경우, 당사의 소재지를 관할하는 인민법원에 제출해야 합니다.',
  'termsOfService.section12.title': 'XII. 기타 조항',
  'termsOfService.section12.1.title': '12.1 조항 수정',
  'termsOfService.section12.1.content': '당사는 언제든지 본 이용약관을 수정할 권리를 보유합니다. 중요한 수정사항은 발효 최소 30일 전에 알려드립니다. 서비스를 계속 사용하는 것은 수정된 조항에 동의하는 것으로 간주됩니다.',
  'termsOfService.section12.2.title': '12.2 분리 가능성',
  'termsOfService.section12.2.content': '본 이용약관의 어떤 조항이 무효 또는 집행 불가능한 것으로 판단되더라도 다른 조항의 효력에 영향을 미치지 않습니다.',
  'termsOfService.section12.3.title': '12.3 완전한 합의',
  'termsOfService.section12.3.content': '본 이용약관은 본 서비스 사용에 관한 귀하와 당사 간의 완전한 합의를 구성하며, 이전의 모든 구두 또는 서면 합의를 대체합니다.',
  'termsOfService.section13.title': 'XIII. 문의하기',
  'termsOfService.section13.intro': '본 이용약관에 대한 질문이 있으시면 다음 방법으로 당사에 연락하시기 바랍니다:',
  'termsOfService.section13.email': '이메일: {email}',
  'termsOfService.section13.hours': '고객 서비스 시간: 평일 9:00-18:00',
  
  // Footer
  'footer.brand.description': 'AI 생성 서비스를 제공합니다.',
  'footer.joinUs': '채용 안내',
  'footer.product.title': '제품',
  'footer.product.signup': '계정 등록',
  'footer.product.login': '로그인',
  'footer.product.workspace': '작업 공간',
  'footer.product.works': '내 작품',
  'footer.support.title': '지원',
  'footer.support.help': '도움말 센터',
  'footer.support.about': '회사 소개',
  'footer.support.feedback': '피드백',
  'footer.support.contact': '문의하기',
  'footer.legal.title': '법적',
  'footer.legal.privacy': '개인정보 보호정책',
  'footer.legal.terms': '서비스 약관',
  'footer.legal.recharge': '충전 약관',
  'footer.resources.title': '리소스',
  'footer.resources.invite': '친구 초대',
  'footer.resources.account': '계정 관리',
  'footer.resources.orders': '주문 센터',
  'footer.copyright': '© {year} {brand}. 모든 권리 보유.',
  'footer.description': '이 플랫폼은 AI 생성 서비스를 제공합니다',
  'footer.openRobotX.title': 'Open Robot X',
  'footer.openRobotX.description': '사양 비교 및 업계 인사이트가 포함된 글로벌 휴머노이드 로봇 데이터베이스',
  'footer.openRobotX.visit': 'Open Robot X 방문',
  'footer.ai2obj.title': 'ai2obj',
  'footer.ai2obj.description': '다양한 디지털 콘텐츠 제작 도구를 제공하는 AI 종합 생성 플랫폼',
  'footer.aimatexMusic.title': 'AIMATEX-MUSIC',
  'footer.aimatexMusic.description': '개인 클라우드 음악: 탐색, 플레이리스트, 재생 중, 클라우드 라이브러리',
  
  // 가격 페이지
  'pricing.title': '당신에게 맞는 플랜을 선택하세요',
  'pricing.plan.basic.sub': '베이직',
  'pricing.plan.pro.sub': '프로',
  'pricing.plan.team.sub': '팀',
  'pricing.plan.popular': '인기',
  'pricing.plan.button.select': '이 플랜 선택',
  'pricing.plan.button.subscribe': '지금 구독',
  'pricing.plan.basic.videoQuota': '5회/월',
  'pricing.plan.basic.videoDuration': '6-10초',
  'pricing.plan.basic.videoQuality': '720P',
  'pricing.plan.pro.videoQuota': '30회/월',
  'pricing.plan.pro.videoDuration': '10-15초',
  'pricing.plan.pro.videoQuality': '1080P',
  'pricing.plan.team.videoQuota': '100회/월',
  'pricing.plan.team.videoDuration': '10-15초',
  'pricing.plan.team.videoQuality': '1080P/4K',
  'pricing.feature.videoQuota': '비디오 생성 할당량',
  'pricing.feature.videoDuration': '비디오 길이',
  'pricing.feature.videoQuality': '비디오 품질',
  'pricing.feature.storyboard': '스토리보드 기능',
  'pricing.feature.workflow': '워크플로우',
  'pricing.feature.priorityQueue': '우선 대기열',
  'pricing.feature.exclusiveChannel': '전용 채널',
  'pricing.feature.highestQuality': '최고 품질 모드',
  'pricing.feature.sdImage': 'SD 이미지 생성',
  'pricing.feature.unlimited': '무제한',
  'pricing.feature.promptOptimization': '프롬프트 최적화',
  'pricing.feature.imageSize': '이미지 크기',
  'pricing.feature.storage': '저장 공간',
  'pricing.feature.commercialLicense': '상업적 라이선스',
  'pricing.feature.apiAccess': 'API 액세스',
  'pricing.then': '이후',
  'cta.title': '비디오 제작을 시작하세요',
  'cta.description': '지금 등록하고 AI 기술로 창의성을 놀라운 비디오 작품으로 변환하세요',
  'cta.button': '무료로 제작 시작하기',
  'technology.coreArchitecture': '핵심 아키텍처',
  'technology.workflowEngine.title': '시각적 워크플로우 엔진',
  'technology.workflowEngine.description': '시각적 워크플로우 지원이 곧 제공됩니다. 각 노드는 창의성에 대한 정밀한 제어입니다.',
  'technology.node.checkpointLoader': 'Checkpoint Loader',
  'technology.node.clipTextPositive': 'CLIP Text (Positive)',
  'technology.node.clipTextNegative': 'CLIP Text (Negative)',
  'technology.node.ksamplerAdvanced': 'KSampler Advanced',
  'technology.node.vaeDecode': 'VAE Decode',
  'technology.node.previewImage': 'Preview Image',
  'technology.hud.systemResourceMonitor': '시스템 리소스 모니터',
  'technology.hud.gpuVram': 'GPU VRAM',
  'technology.terminal.console': 'console — zsh',
  'technology.button.runWorkflow': '워크플로우 실행',
  'technology.button.running': '실행 중...',
  'technology.log.systemInitialized': '> 시스템이 초기화되었습니다.',
  'technology.log.waitingForInput': '> 사용자 입력 대기 중...',
  'technology.log.loadingCheckpoint': 'Loading SDXL Checkpoint (fp16)...',
  'technology.log.tokenizingPrompt': 'Tokenizing positive prompt...',
  'technology.log.ksamplerSteps': 'KSampler: 30/30 steps (Euler A)',
  'technology.log.generationComplete': 'Generation complete.',
  'technology.benchmark.title': '궁극의 성능 벤치마크',
  'technology.benchmark.description': '이 0.5초 개선을 위해 기본 연산자의 30%를 다시 작성했습니다.',
  'technology.benchmark.fps.title': '생성 속도 (FPS)',
  'technology.benchmark.fps.subtitle': 'Comparison @ 1080p',
  'technology.benchmark.vram.title': 'VRAM 최적화',
  'technology.benchmark.vram.subtitle': 'Lower is better',
  'technology.benchmark.productX': 'ProductX',
  'technology.benchmark.others': 'Others',
  'technology.benchmark.standard': 'Standard',
  'technology.galaxy.openEcology': '오픈 생태계',
  'technology.galaxy.title': '무한 모델 우주',
  'technology.galaxy.description': 'Civitai 직접 연결 지원, 수천 개의 모델, 원클릭 로드.',
  'technology.galaxy.autoSync': '자동 동기화',
  
  // 피드백 페이지
  'feedback.leftPanel.title.line1': '우리는',
  'feedback.leftPanel.title.line2': '당신의 목소리를 듣습니다',
  'feedback.leftPanel.description': '귀하의 피드백은 우리 제품 개선의 원동력입니다. 버그를 발견했거나 훌륭한 새 기능 아이디어가 있으시면 알려주세요.',
  'feedback.contact.helpDoc.title': '도움말 문서',
  'feedback.contact.helpDoc.desc': 'FAQ 및 사용자 가이드 참조',
  'feedback.contact.email.title': '이메일 지원',
  'feedback.contact.service.title': '온라인 지원',
  'feedback.contact.service.hours': '평일 9:00 - 18:00',
  'feedback.type.suggestion.title': '기능 제안',
  'feedback.type.suggestion.desc': '새로운 아이디어나 개선 제안이 있습니다',
  'feedback.type.bug.title': '버그 보고',
  'feedback.type.bug.desc': '오류나 예외가 발생했습니다',
  'feedback.type.question.title': '사용 문의',
  'feedback.type.question.desc': '기능 사용 방법을 모르겠습니다',
  'feedback.type.other.title': '기타',
  'feedback.type.other.desc': '기타 피드백',
  'feedback.form.type.label': '피드백 유형',
  'feedback.form.title.label': '간단한 요약',
  'feedback.form.title.placeholder': '문제나 제안을 한 문장으로 설명하세요',
  'feedback.form.title.required': '제목을 입력하세요',
  'feedback.form.content.label': '상세 설명',
  'feedback.form.content.placeholder': '배경, 재현 단계 또는 구체적인 제안을 자세히 설명하세요...',
  'feedback.form.content.required': '상세 내용을 입력하세요',
  'feedback.form.attachment.label': '첨부 파일 (선택사항)',
  'feedback.upload.dragText': '클릭하거나 파일을 드래그하여 업로드',
  'feedback.upload.hint': 'JPG, PNG, PDF 등 형식 지원, 단일 파일 크기 5MB 이하',
  'feedback.upload.sizeLimit': '파일 크기는 5MB를 초과할 수 없습니다',
  'feedback.form.priority.label': '우선순위',
  'feedback.priority.low.label': '낮음',
  'feedback.priority.low.desc': '사용에 영향 없음',
  'feedback.priority.medium.label': '중간',
  'feedback.priority.medium.desc': '사용자 경험에 영향',
  'feedback.priority.high.label': '높음',
  'feedback.priority.high.desc': '사용을 심각하게 방해함',
  'feedback.form.contact.label': '연락처 (선택사항)',
  'feedback.form.contact.placeholder': '이메일 또는 전화번호',
  'feedback.form.submit': '피드백 제출',
  'feedback.submit.error': '제출 실패, 나중에 다시 시도하세요',
  'feedback.success.title': '피드백이 접수되었습니다!',
  'feedback.success.description': '소중한 피드백을 주셔서 감사합니다. 제품 팀은 모든 피드백을 주의 깊게 읽을 것입니다. 버그 보고인 경우 제공된 연락처를 통해 연락할 수 있습니다.',
  'feedback.success.back': '돌아가기',
  'feedback.success.another': '다시 제출',
  // 초대 페이지
  'invite.partnerProgram': '파트너 프로그램',
  'invite.title.line1': '친구 초대',
  'invite.title.line2': '무한한 가치 창출',
  'invite.reward.inviter': '친구를 초대할 때마다 {amount} 현금 보상을 받으세요.',
  'invite.reward.invitee': '친구는 가입 시 {amount} 신규 혜택을 받습니다.',
  'invite.step1.title': '1. 링크 공유',
  'invite.step1.desc': 'SNS를 통해 전용 링크 공유',
  'invite.step2.title': '2. 친구 활성화',
  'invite.step2.desc': '친구가 가입 및 인증 완료',
  'invite.step3.title': '3. 수익 출금',
  'invite.step3.desc': '수익 즉시 입금, 잔액으로 출금 가능',
  'invite.exclusiveCode': 'YOUR EXCLUSIVE CODE',
  'invite.copyCode': '코드 복사',
  'invite.viewQrcode': 'QR 코드 보기',
  'invite.stats.totalInvites': '총 초대',
  'invite.stats.availableReward': '출금 가능 금액',
  'invite.stats.totalReward': '총 수익',
  'invite.withdrawNow': '지금 출금',
  'invite.history.title': '초대 기록',
  'invite.filter.all': '전체',
  'invite.filter.active': '활성화',
  'invite.filter.pending': '대기 중',
  'invite.status.credited': '입금됨',
  'invite.status.pending': '대기 중',
  'invite.history.empty': '기록 없음',
  'invite.withdraw.title': '수익 출금',
  'invite.withdraw.cancel': '취소',
  'invite.withdraw.confirm': '출금 확인',
  'invite.withdraw.amount': '출금 금액',
  'invite.withdraw.note': '* 금액은 계정 잔액으로 직접 이체됩니다.',
  'invite.withdraw.enterAmount': '출금 금액을 입력하세요',
  'invite.withdraw.insufficientBalance': '잔액 부족',
  'invite.withdraw.success': '¥{amount}을(를) 잔액으로 출금했습니다',
  'invite.qrcode.title': '스캔하여 참여',
  'invite.copyLink': '링크 복사',
  'invite.copy.success': '복사 완료',
  // 홈 히어로 섹션
  'home.hero.badge': 'AI 어시스턴트 · 동반자 · 파트너',
  'home.hero.title': 'AIMATEX',
  'home.hero.subtitle': '당신의 동급생, 소울메이트, 팀메이트',
  'home.hero.description': 'AIMATEX는 당신의 AI 어시스턴트, 학습 파트너, 창의적 동반자입니다. 포괄적인 AI 솔루션을 제공하여 AI를 업무, 학습, 창작에서 최고의 파트너로 만듭니다. 교실 학습, 창의적 협업, 팀 협력이든 AIMATEX는 신뢰할 수 있는 파트너입니다.',
  'home.hero.cta.signup': '무료로 시작하기',
  'home.hero.cta.login': '로그인',
  'home.hero.cta.workspace': '작업 공간으로 이동',
  // 홈 제품 섹션
  'home.products.title': '우리 제품',
  'home.products.subtitle': 'AIMATEX의 혁신적인 AI 제품을 탐색하세요. 각 제품은 다양한 시나리오에서 최고의 파트너입니다',
  'home.products.seedance2.name': 'Seedance2',
  'home.products.seedance2.description': 'AI 이미지-비디오 생성 파트너, 정적 이미지를 동적 비디오로 변환하여 창의성을 살립니다',
  'home.products.ai2obj.name': 'AI2Obj',
  'home.products.ai2obj.description': 'AI 기반 3D 객체 생성 및 변환 플랫폼, 당신의 3D 창작 파트너',
  'home.products.openrobotx.name': 'OpenRobotX',
  'home.products.openrobotx.description': '글로벌 휴머노이드 로봇 회사, 매개변수 비교 및 업계 인사이트 탐색, 당신의 로봇 연구 파트너',
  'home.products.openclaw4j.name': 'OpenClaw4j',
  'home.products.openclaw4j.title': 'OpenClaw4j',
  'home.products.openclaw4j.description': '자율 에이전트 플랫폼 — OpenForgeX로 지능형 에이전트 구축 및 배포',
  'home.products.openclaw4j.cta': '에이전트 체험',
  'home.products.aimatexMusic.name': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.title': 'AIMATEX-MUSIC',
  'home.products.aimatexMusic.description': '개인 클라우드 음악 공간 — 곡 탐색, 협업 플레이리스트, 지금 재생 중, 클라우드 음원 라이브러리',
  'home.products.aimatexMusic.cta': '음악 들어가기',
  'home.music.eyebrow': 'AIMATEX 스위트',
  'home.music.title': 'AIMATEX-MUSIC',
  'home.music.subtitle': '개인 클라우드 음악 공간 — 탐색, 수집, 함께 듣기.',
  'home.music.feature.discover.title': '발견',
  'home.music.feature.discover.desc': '곡을 검색해 클라우드 라이브러리로 가져오기.',
  'home.music.feature.playlist.title': '플레이리스트',
  'home.music.feature.playlist.desc': '협업 플레이리스트 생성과 공유.',
  'home.music.feature.nowPlaying.title': '지금 재생',
  'home.music.feature.nowPlaying.desc': '동기화 청취, 좋아요, 재생 기록.',
  'home.music.feature.cloud.title': '클라우드 라이브러리',
  'home.music.feature.cloud.desc': '고음질 오디오를 클라우드에 안전하게 저장.',
  'home.music.cta': 'AIMATEX-MUSIC 열기',
'home.showcase.seedance2.eyebrow': 'Image to Video',
  'home.showcase.seedance2.title': 'Seedance2',
  'home.showcase.seedance2.subtitle': 'Turn still frames into cinematic motion with a next-gen creation engine.',
  'home.showcase.seedance2.f1.title': 'Image to Video',
  'home.showcase.seedance2.f1.desc': 'Upload a photo — AI invents light and motion.',
  'home.showcase.seedance2.f2.title': 'Cinema Quality',
  'home.showcase.seedance2.f2.desc': 'High-res output with stable, crisp detail.',
  'home.showcase.seedance2.f3.title': 'Smart Prompts',
  'home.showcase.seedance2.f3.desc': 'AI polishes rough ideas into film-ready prompts.',
  'home.showcase.seedance2.f4.title': 'Style Switch',
  'home.showcase.seedance2.f4.desc': 'Cyberpunk, oil paint, anime — one click.',
  'home.showcase.seedance2.cta': 'Enter Seedance2',
  'home.showcase.ai2obj.eyebrow': '3D Generation',
  'home.showcase.ai2obj.title': 'AI2Obj',
  'home.showcase.ai2obj.subtitle': 'An AI generation platform that turns ideas into usable digital assets.',
  'home.showcase.ai2obj.f1.title': 'Multimodal',
  'home.showcase.ai2obj.f1.desc': 'From text and images to 3D and content assets.',
  'home.showcase.ai2obj.f2.title': 'Object Convert',
  'home.showcase.ai2obj.f2.desc': 'Structure understanding and format conversion.',
  'home.showcase.ai2obj.f3.title': 'Creator Workflow',
  'home.showcase.ai2obj.f3.desc': 'Pipelines built for product and content teams.',
  'home.showcase.ai2obj.f4.title': 'Cloud Delivery',
  'home.showcase.ai2obj.f4.desc': 'Preview, export, and collaborate in the cloud.',
  'home.showcase.ai2obj.cta': 'Visit AI2Obj',
  'home.showcase.openrobotx.eyebrow': 'Robotics Intel',
  'home.showcase.openrobotx.title': 'OpenRobotX',
  'home.showcase.openrobotx.subtitle': 'Global humanoid robot companies, specs, and industry insights in one place.',
  'home.showcase.openrobotx.f1.title': 'World Map',
  'home.showcase.openrobotx.f1.desc': 'Major humanoid vendors and products covered.',
  'home.showcase.openrobotx.f2.title': 'Spec Compare',
  'home.showcase.openrobotx.f2.desc': 'Clear side-by-side capability and positioning.',
  'home.showcase.openrobotx.f3.title': 'Industry News',
  'home.showcase.openrobotx.f3.desc': 'Funding, launches, and tech movements tracked.',
  'home.showcase.openrobotx.f4.title': 'Research Partner',
  'home.showcase.openrobotx.f4.desc': 'Structured intel for selection and research.',
  'home.showcase.openrobotx.cta': 'Explore OpenRobotX',
  'home.showcase.openclaw4j.eyebrow': 'Autonomous Agents',
  'home.showcase.openclaw4j.title': 'OpenClaw4j',
  'home.showcase.openclaw4j.subtitle': 'Build and deploy intelligent agents with OpenForgeX — make agents run for real.',
  'home.showcase.openclaw4j.f1.title': 'Agent Orchestration',
  'home.showcase.openclaw4j.f1.desc': 'Multi-step planning and execution.',
  'home.showcase.openclaw4j.f2.title': 'Tool Calling',
  'home.showcase.openclaw4j.f2.desc': 'Connect APIs and business systems.',
  'home.showcase.openclaw4j.f3.title': 'Observable Runs',
  'home.showcase.openclaw4j.f3.desc': 'Transparent traces for debug and iteration.',
  'home.showcase.openclaw4j.f4.title': 'One-click Deploy',
  'home.showcase.openclaw4j.f4.desc': 'From prototype to live service fast.',
  'home.showcase.openclaw4j.cta': 'Try Agent',
  'home.products.learnMore': '자세히 알아보기',
  // 홈 기능 섹션
  'home.features.title': '올인원 창작 작업실.',
  'home.features.subtitle': '단순한 비디오 생성을 넘어 창의성의 전방위 강화.',
  'home.features.aiPrompt.title': '프롬프트 작성 어려우신가요? AI가 작성해드립니다',
  'home.features.aiPrompt.description': '영감이 전혀 없으신가요? 원클릭으로 AI가 작성해드립니다. 몇 단어만 입력하면 AI가 자동으로 영화 수준의 설명으로 다듬어주며, 10초 만에 완성됩니다. 스타일을 바꾸고 싶으신가요? 다시 한 번 클릭하면 사이버펑크/유화/애니메이션으로 즉시 변환됩니다.',
  'home.features.demo.userInput': '고양이',
  'home.features.demo.aiResult': '우아한 페르시안 고양이, 부드럽고 푹신한 흰색 긴 털, 호박색 큰 눈동자, 햇살이 비치는 창가에 앉아있습니다. 배경은 연한 파란 하늘과 흩날리는 하얀 커튼. 4K 고화질, 영화 같은 조명, 피사계 심도, 전문 사진 촬영.',
  'home.features.demo.buttonText': 'AI 생성',
  'home.features.demo.buttonLoading': '생성 중',
  'home.features.demo.thinkingText': 'AI 제작 중✨',
  'home.features.quality.title': '영화 품질',
  'home.features.quality.description': '기본적으로 4K 해상도 출력을 지원하며, 모든 프레임이 섬세합니다.',
  'home.features.imageToVideo.title': '이미지를 비디오로',
  'home.features.imageToVideo.description': '정적 이미지를 업로드하면 AI가 장면의 조명과 물리 관계를 이해하고 자동으로 후속 동작을 생성하여 사진에 생명을 불어넣습니다.',
  'home.features.multimodal.title': '멀티모달 생태계',
  'home.features.multimodal.description': 'Stable Diffusion 텍스트-이미지뿐만 아니라 Midjourney 스타일 전송 및 ElevenLabs 오디오 합성도 통합했습니다. 하나의 워크플로우에서 모든 창작을 완료하세요.',
  
  // 홈 커뮤니티 섹션
  'home.community.title': 'AI 크리에이티브 커뮤니티 탐색',
  'home.community.subtitle': '수백만 명의 크리에이터와 함께하고, AI 걸작을 공유하며, 영감과 피드백을 얻으세요',
  'home.community.hot': '인기',
  'home.community.explore': '커뮤니티 탐색',
  'home.community.stats.works': '작품',
  'home.community.stats.creators': '크리에이터',
  'home.community.stats.views': '조회수',
  'home.community.image.title': 'AI 이미지 커뮤니티',
  'home.community.image.description': '포토리얼리스틱부터 예술적, 일러스트부터 사진까지 AI가 생성한 놀라운 이미지를 발견하고 공유하세요',
  'home.community.video.title': 'AI 비디오 커뮤니티',
  'home.community.video.description': 'AI가 생성한 놀라운 비디오를 탐색하고, 창의적인 기술을 배우며, 전 세계 비디오 크리에이터와 경험을 교환하세요',
  'home.community.music.title': 'AI 음악 커뮤니티',
  'home.community.music.description': 'AI가 작곡한 아름다운 멜로디를 듣고, 음악 작품을 공유하며, 같은 생각을 가진 음악 애호가를 찾으세요',
  'home.community.3d.title': 'AI 3D 모델 커뮤니티',
  'home.community.3d.description': '건축부터 캐릭터, 게임부터 산업 디자인까지 AI가 생성한 3D 모델의 세계를 탐험하세요',
  'home.community.voice.title': 'AI 음성 커뮤니티',
  'home.community.voice.description': '사실적인 AI 음성 합성, 더빙, 오디오북, 음성 복제를 경험하고 창작에 생명을 불어넣으세요',
  'home.community.text.title': 'AI 텍스트 커뮤니티',
  'home.community.text.description': 'AI가 만든 우수한 텍스트, 소설, 시, 대본, 카피를 공유하고 문학적 창의성을 고취하세요',
  
  // Billing 페이지
  'billing.page.title': '재무 센터',
  'billing.page.description': '자금 거래 및 청구 내역 관리',
  'billing.button.refresh': '새로고침',
  'billing.button.recharge': '충전',
  'billing.button.reset': '재설정',
  'billing.button.apply': '필터 적용',
  'billing.balance.cny': 'CNY 잔액',
  'billing.balance.usdt': 'USDT 잔액',
  'billing.balance.usd': 'USD 잔액',
  'billing.balance.token': '토큰 잔액',
  'billing.balance.frozen': '동결',
  'billing.type.frozen': '자금 동결',
  'billing.type.aiModelFee': '모델 호출',
  'billing.type.recharge': '충전',
  'billing.type.refund': '환불',
  'billing.type.reward': '보상',
  'billing.type.all': '모든 유형',
  'billing.coin.all': '모든 통화',
  'billing.coin.usdt': 'USDT',
  'billing.coin.cny': 'CNY',
  'billing.coin.usd': 'USD',
  'billing.coin.token': 'TOKEN',
  'billing.table.type': '유형',
  'billing.table.coinType': '통화',
  'billing.table.time': '시간',
  'billing.table.amount': '금액',
  'billing.table.remark': '비고',
  'billing.table.balance': '잔액',
  'billing.table.empty': '청구서 없음',
  'billing.filter.title': '필터 조건',
  'billing.filter.button': '필터 및 날짜',
  'billing.filter.changeType': '변경 유형',
  'billing.filter.coinType': '통화 유형',
  'billing.filter.remark': '비고 검색',
  'billing.filter.remarkPlaceholder': '비고 키워드 입력',
  'billing.filter.remarkSearch': '비고 검색',
  'billing.filter.dateQuick': '빠른 날짜',
  'billing.filter.dateCustom': '사용자 정의 날짜',
  'billing.filter.dateTo': '까지',
  'billing.filter.days7': '최근 7일',
  'billing.filter.days30': '최근 30일',
  'billing.filter.days90': '최근 3개월',
  'billing.placeholder.changeType': '변경 유형',
  'billing.placeholder.coinType': '통화',
  'billing.placeholder.remark': '비고 검색',
  'billing.message.fetchBalanceError': '잔액 조회 실패',
  'billing.message.fetchRecordsError': '청구 기록 조회 실패',
  'billing.message.tryAgain': '청구 기록 조회 실패, 나중에 다시 시도하세요',
  
  // Recharge 충전 페이지
  'recharge.page.title': '계정 충전',
  'recharge.page.backLink': '재무 센터로 돌아가기',
  'recharge.balance.title': '계정 잔액',
  'recharge.balance.refresh': '새로고침',
  'recharge.section.coinType': '충전 통화',
  'recharge.section.paymentMethod': '결제 수단',
  'recharge.section.amount': '충전 금액',
  'recharge.order.title': '주문 상세',
  'recharge.order.type': '충전 유형',
  'recharge.order.typeValue': '계정 잔액 충전',
  'recharge.order.account': '충전 계정',
  'recharge.order.accountLoading': '로딩 중...',
  'recharge.order.paymentMethod': '결제 수단',
  'recharge.order.paymentMethodPlease': '선택하세요',
  'recharge.order.total': '총 금액',
  'recharge.button.pay': '즉시 결제',
  'recharge.button.customize': '사용자 정의 금액',
  'recharge.placeholder.customAmount': '사용자 정의 금액 입력',
  'recharge.security.ssl': 'SSL 암호화 전송, 자금 안전 보장',
  'recharge.security.agreement': '결제를 클릭하면 동의하는 것입니다',
  'recharge.security.agreementLink': '충전 서비스 약관',
  'recharge.empty.noCurrency': '지원되는 통화 없음',
  'recharge.empty.noPaymentMethod': '{currency} 통화의 결제 수단을 지원하지 않습니다',
  'recharge.empty.pleaseSelectCurrency': '먼저 충전 통화를 선택하세요',
  'recharge.empty.pleaseSelectPayment': '먼저 결제 수단을 선택하세요',
  'recharge.empty.noProducts': '사용 가능한 제품 없음',
  'recharge.empty.noPresets': '{currency} 통화의 사전 설정 금액을 지원하지 않습니다',
  'recharge.message.invalidAmount': '유효한 금액을 입력하세요',
  'recharge.message.selectPaymentMethod': '결제 수단을 선택하세요',
  'recharge.message.selectAmount': '충전 금액을 선택하세요',
  'recharge.message.fetchBalanceError': '잔액 조회 실패, 나중에 다시 시도하세요',
  'recharge.message.fetchUserInfoError': '사용자 정보 조회 실패',
  'recharge.message.fetchCurrenciesError': '통화 목록 조회 실패, 나중에 다시 시도하세요',
  'recharge.message.fetchPaymentMethodsError': '결제 수단 조회 실패, 나중에 다시 시도하세요',
  'recharge.message.fetchCreemProductsError': 'Creem 제품 목록 조회 실패, 나중에 다시 시도하세요',
  'recharge.message.fetchCreemProductsWarning': 'Creem 제품 목록 조회 실패',
  'recharge.message.orderCreated': '주문이 성공적으로 생성되었습니다',
  'recharge.message.orderCreateFailed': '충전 주문 생성 실패',
  'recharge.message.paymentProcessing': '결제 페이지를 여는 중, 결제를 완료하세요...',
  'recharge.message.popupBlocked': '결제 창을 열 수 없습니다. 브라우저 팝업 설정을 확인하세요',
  'recharge.message.paymentUrlError': '결제 링크 가져오기 실패',
  'recharge.message.checkoutSessionError': '결제 세션 생성 실패',
  'recharge.message.paymentError': '결제 처리 실패, 나중에 다시 시도하세요',
  'recharge.message.redirecting': '결제 페이지로 리디렉션 중, 결제를 완료하세요...',
  'recharge.message.paymentUrlFailed': '결제 링크를 사용할 수 없습니다',
  'recharge.message.paymentSuccess': '결제 성공! 잔액이 업데이트되었습니다',
  'recharge.message.orderCancelled': '주문이 취소되었습니다',
  'recharge.message.paymentFailed': '결제 실패',
  'recharge.message.orderExpired': '만료됨',
  'recharge.message.queryOrderError': '주문 상태 조회 실패',
  'recharge.message.rechargeError': '충전 요청 실패, 나중에 다시 시도하세요',

  // 주문 페이지
  'orders.title': '주문 내역',
  'orders.subtitle': '모든 충전 주문 기록 및 상태 보기',
  'orders.refresh': '새로고침',
  'orders.goToRecharge': '충전하기',

  // 통계 카드
  'orders.stats.totalOrders': '총 주문 수',
  'orders.stats.pending': '대기 중',
  'orders.stats.paid': '결제 완료',
  'orders.stats.totalAmount': '총 충전 금액',

  // 테이블 열
  'orders.table.orderNo': '주문 번호',
  'orders.table.createTime': '생성일',
  'orders.table.amount': '금액',
  'orders.table.paymentMethod': '결제 방법',
  'orders.table.status': '상태',
  'orders.table.action': '작업',
  'orders.table.view': '보기',
  'orders.table.cancel': '취소',
  'orders.table.empty': '주문 기록이 없습니다',

  // 주문 상태
  'orders.status.pending': '대기 중',
  'orders.status.paid': '결제 완료',
  'orders.status.success': '완료',
  'orders.status.cancelled': '취소됨',
  'orders.status.failed': '실패',
  'orders.status.expired': '만료됨',
  'orders.status.all': '모든 상태',

  // 결제 방법
  'orders.payment.alipay': 'Alipay',
  'orders.payment.wechat': 'WeChat Pay',
  'orders.payment.bank': '은행 카드',
  'orders.payment.usdt': 'USDT',
  'orders.payment.creem': 'Creem',
  'orders.payment.all': '모든 방법',

  // 통화
  'orders.coin.all': '모든 통화',

  // 필터
  'orders.filter.title': '필터 옵션',
  'orders.filter.button': '주문 필터링',
  'orders.filter.reset': '재설정',
  'orders.filter.apply': '적용',
  'orders.filter.orderStatus': '주문 상태',
  'orders.filter.paymentMethod': '결제 방법',
  'orders.filter.coinType': '통화 유형',
  'orders.filter.orderNoSearch': '주문 번호 검색',
  'orders.filter.quickDate': '빠른 날짜',
  'orders.filter.customDate': '사용자 지정 날짜',
  'orders.filter.dateTo': '~',
  'orders.filter.last7Days': '최근 7일',
  'orders.filter.last30Days': '최근 30일',
  'orders.filter.last3Months': '최근 3개월',

  // 검색 및 입력
  'orders.search.placeholder': '주문 번호 검색',
  'orders.input.orderNo': '주문 번호 입력',
  'orders.select.orderStatus': '주문 상태',
  'orders.select.paymentMethod': '결제 방법',
  'orders.select.coinType': '통화',

  // 메시지
  'orders.message.fetchError': '주문을 가져오지 못했습니다',
  'orders.message.fetchErrorRetry': '주문을 가져오지 못했습니다. 나중에 다시 시도하세요',
  'orders.message.statsError': '통계를 가져오지 못했습니다',
  'orders.message.cancelSuccess': '주문이 취소되었습니다',
  'orders.message.cancelError': '주문 취소 실패',
  'orders.message.cancelErrorRetry': '주문 취소 실패. 나중에 다시 시도하세요',
  'orders.message.viewOrder': '주문 번호: {orderNo}',

  // 확인 대화 상자
  'orders.confirm.cancel': '이 주문을 취소하시겠습니까?',
  'orders.confirm.ok': '확인',
  'orders.confirm.cancelButton': '취소',

  // 채용 페이지
  'joinUs.seo.title': 'PROTX 합류 - 극한의 추구',
  'joinUs.seo.description': 'PROTX 팀에 합류하여 궁극의 사용자 경험과 제품 디자인을 함께 추구하세요',
  'joinUs.hero.eyebrow': 'JOIN PROTX',
  'joinUs.hero.title': '극한의 추구',
  'joinUs.hero.title2': '디자인으로 미래를 정의하다',
  'joinUs.hero.subtitle': 'PROTX는 궁극의 사용자 경험과 제품 디자인을 추구하는 팀입니다. 모든 픽셀에는 의미가 있고, 모든 인터랙션은 정교하게 다듬을 가치가 있다고 믿습니다. 탁월함에 대한 집념을 공유한다면, 함께하세요.',
  'joinUs.hero.cta': '채용 공고 보기',
  'joinUs.hero.video': '팀 스토리 보기',
  
  'joinUs.values.eyebrow': '우리의 철학',
  'joinUs.values.title': '핵심 가치',
  'joinUs.values.subtitle': '이 핵심 가치는 우리가 누구이며 어떻게 함께 일하는지를 정의합니다',
  'joinUs.values.innovation.title': '혁신 주도',
  'joinUs.values.innovation.desc': '혁신이 세상을 바꾸는 힘이라고 믿으며, 모든 혁신적인 아이디어를 장려합니다.',
  'joinUs.values.collaboration.title': '협업 성공',
  'joinUs.values.collaboration.desc': '팀 간 협업으로 비범한 성과를 함께 창출합니다.',
  'joinUs.values.excellence.title': '탁월함 추구',
  'joinUs.values.excellence.desc': '끊임없이 한계를 넘어 궁극의 경험을 추구합니다.',
  'joinUs.values.passion.title': '열정과 집중',
  'joinUs.values.passion.desc': '기술에 대한 열정, 제품에 대한 헌신.',
  'joinUs.values.impact.title': '임팩트 창출',
  'joinUs.values.impact.desc': 'AI 기술로 모든 사람의 창의적 표현을 지원합니다.',
  
  'joinUs.positions.eyebrow': '채용 공고',
  'joinUs.positions.title': '채용 공고',
  'joinUs.positions.subtitle': '자신에게 맞는 역할을 찾고 새로운 커리어 여정을 시작하세요',
  'joinUs.category.engineering': '엔지니어링',
  'joinUs.category.product': '제품 및 디자인',
  'joinUs.category.operations': '운영 및 마케팅',
  'joinUs.position.seniorFrontend': '시니어 프론트엔드 엔지니어',
  'joinUs.position.backendEngineer': '백엔드 엔지니어',
  'joinUs.position.mlEngineer': 'AI/ML 엔지니어',
  'joinUs.position.productManager': '프로덕트 매니저',
  'joinUs.position.uxDesigner': 'UX 디자이너',
  'joinUs.position.communityManager': '커뮤니티 매니저',
  'joinUs.position.contentCreator': '콘텐츠 크리에이터',
  'joinUs.location.remote': '원격',
  'joinUs.location.beijing': '베이징',
  'joinUs.location.shanghai': '상하이',
  'joinUs.location.shenzhen': '선전',
  'joinUs.type.fulltime': '정규직',
  'joinUs.type.parttime': '파트타임',
  
  'joinUs.benefits.eyebrow': '복리후생',
  'joinUs.benefits.title': '우리가 제공하는 것',
  'joinUs.benefits.subtitle': '우리와 함께하고 종합적인 혜택과 지원을 받으세요',
  'joinUs.benefit.flexible.title': '유연 근무',
  'joinUs.benefit.flexible.desc': '유연한 근무 시간과 원격 근무 옵션',
  'joinUs.benefit.equity.title': '스톡 옵션',
  'joinUs.benefit.equity.desc': '회사와 함께 성장하고 성공을 공유',
  'joinUs.benefit.health.title': '건강 보험',
  'joinUs.benefit.health.desc': '종합 의료 보험과 건강 혜택',
  'joinUs.benefit.growth.title': '커리어 성장',
  'joinUs.benefit.growth.desc': '지속적인 학습과 성장 기회',
  
  'joinUs.cta.title': '시작할 준비가 되셨나요?',
  'joinUs.cta.subtitle': '우리의 미션에 열정을 가지고 계시다면, 지원을 기다리고 있습니다',
  'joinUs.cta.button': '지금 지원하기',
  
  'joinUs.modal.title': '직무 지원',
  'joinUs.apply.success': '지원서가 제출되었습니다. 곧 연락드리겠습니다!',
  'joinUs.form.name': '이름',
  'joinUs.form.name.required': '이름을 입력해 주세요',
  'joinUs.form.name.placeholder': '이름 입력',
  'joinUs.form.email': '이메일',
  'joinUs.form.email.required': '이메일을 입력해 주세요',
  'joinUs.form.email.invalid': '유효한 이메일 주소를 입력해 주세요',
  'joinUs.form.email.placeholder': '이메일 입력',
  'joinUs.form.phone': '전화번호',
  'joinUs.form.phone.placeholder': '전화번호 입력',
  'joinUs.form.experience': '경력',
  'joinUs.form.experience.placeholder': '경력 선택',
  'joinUs.form.experience.0-2': '0-2년',
  'joinUs.form.experience.3-5': '3-5년',
  'joinUs.form.experience.5-10': '5-10년',
  'joinUs.form.experience.10+': '10년 이상',
  'joinUs.form.resume': '이력서',
  'joinUs.form.resume.hint': '클릭하거나 파일을 드래그하여 업로드',
  'joinUs.form.resume.format': 'PDF, DOC, DOCX 형식 지원',
  'joinUs.form.message': '자기소개',
  'joinUs.form.message.placeholder': '자기소개와 지원 동기를 알려주세요',
  'joinUs.form.submit': '지원하기',
  'joinUs.form.loginTip': '로그인 후 지원하면 지원 내역을 확인할 수 있습니다',
  'joinUs.form.goLogin': '로그인',
  'joinUs.form.resume.sizeLimit': '파일 크기는 10MB를 초과할 수 없습니다',
  
  // 지원 내역
  'joinUs.myApplications.eyebrow': '지원 내역',
  'joinUs.myApplications.title': '지원 기록',
  'joinUs.myApplications.empty': '아직 지원 내역이 없습니다. 지금 이력서를 제출하세요!',
  'joinUs.myApplications.viewDetail': '상세 보기',
  'joinUs.myApplications.detailTitle': '지원 상세',
  'joinUs.status.pending': '대기 중',
  'joinUs.status.reviewing': '검토 중',
  'joinUs.status.interview': '면접 중',
  'joinUs.status.accepted': '합격',
  'joinUs.status.rejected': '불합격',
  'joinUs.detail.basicInfo': '기본 정보',
  'joinUs.detail.positionInfo': '직무 정보',
  'joinUs.detail.position': '지원 직무',
  'joinUs.detail.category': '카테고리',
  'joinUs.detail.location': '근무지',
  'joinUs.detail.applyTime': '지원 일시',
  'joinUs.detail.downloadResume': '이력서 다운로드',
  'joinUs.detail.status': '지원 상태',

  // About 페이지
  'about.hero.title1': '오픈소스 코어.',
  'about.hero.title2': '무한한 가능성.',
  'about.hero.subtitle1': '',
  'about.hero.subtitle2': '와',
  'about.hero.subtitle3': '생태계 기반.',
  'about.hero.description': '최첨단 2025년 생성 AI 기술 스택을 궁극의 인터랙티브 경험으로 패키징합니다.',
  'about.tech.poweredBy': 'Powered by',
  'about.philosophy.title1': '생성 그 이상.',
  'about.philosophy.title2': '이것은 전체 프로세스',
  'about.philosophy.title3': '창의성 엔진.',
  'about.philosophy.description': '텍스트-이미지의 정밀 제어부터 비디오 생성의 물리 시뮬레이션까지, 우리는 기술의 한계를 추구합니다.',
  'about.bento.comfy.title': '노드 수준의 정밀 제어.',
  'about.bento.comfy.description': 'ComfyUI 노드 기반 아키텍처를 채택하여 ControlNet 포즈 제어와 IP-Adapter 스타일 전송을 지원합니다. 복잡한 노드 로직을 직관적인 슬라이더로 캡슐화하여 모든 생성을 원하는 대로 구현합니다.',
  'about.bento.opensource.title': '오픈소스를 수용.',
  'about.bento.opensource.description': 'Stable Diffusion 3.5 & XL Turbo 기반. 빠른 생성 속도뿐만 아니라 커뮤니티의 방대한 LoRA 모델 지원도 제공합니다.',
  'about.bento.video.title': 'DiT 비디오 아키텍처.',
  'about.bento.video.description': 'Diffusion Transformer (DiT)와 시공간 어텐션 메커니즘을 도입하여 SORA 수준의 물리 세계 시뮬레이션을 달성합니다.',
  'about.bento.audio.title': '오디오-비주얼 동기화, 감각의 각성.',
  'about.bento.audio.description': '시각 그 이상입니다. 최신 오디오 생성 모델과 통합하여 Text-to-Audio 및 자동 비디오 정렬을 지원합니다. 시각에서 청각까지, 완전한 몰입형 경험을 구축합니다.',
  'about.techSection.title': '기술 아키텍처.',
  'about.techSection.description': 'ProductX를 구동하는 코어 엔진을 깊이 이해하세요.',
  'about.techCard.sd.title': '생성 아트의 기반.',
  'about.techCard.sd.description': '최신 Stable Diffusion 생성 모델을 깊이 통합했습니다. 맞춤형 VAE와 최적화된 샘플러를 통해 세밀한 이미지 품질을 유지하면서 생성 속도를 300% 향상시켰습니다.',
  'about.techCard.spec.baseModel': '베이스 모델',
  'about.techCard.spec.resolution': '해상도',
  'about.techCard.spec.resolution.value': '최대 4K 업스케일링',
  'about.techCard.spec.control': '제어',
  'about.techCard.spec.speed': '속도',
  'about.techCard.spec.speed.value': '< 1초 (터보 모드)',
  'about.techCard.video.title': '차세대 비디오 물리 엔진.',
  'about.techCard.video.description': '기존 2D 애니메이션 로직을 버리고 2025년 최신 DiT (Diffusion Transformer) 아키텍처를 채택했습니다. 모델은 조명, 중력, 물체 운동 물리를 이해하여 단순한 비디오가 아닌 물리적으로 정확한 동적 세계를 생성합니다.',
  'about.techCard.spec.architecture': '아키텍처',
  'about.techCard.spec.frameRate': '프레임 레이트',
  'about.techCard.spec.frameRate.value': '24 / 60 FPS 보간',
  'about.techCard.spec.consistency': '일관성',
  'about.techCard.spec.consistency.value': '높은 시간적 안정성',
  'about.techCard.spec.length': '길이',
  'about.techCard.spec.length.value': '무한 루프 확장',
  'about.techCard.img2img.title': '이미지-이미지 & 스타일 전송.',
  'about.techCard.img2img.description': 'IP-Adapter와 T2I-Adapter 기술을 사용하여 제로샷 스타일 전송을 구현합니다. 참조 이미지를 업로드하면 즉시 구도, 조명, 아트 스타일을 복제하여 무한한 창작 가능성을 열어줍니다.',
  'about.techCard.spec.technology': '기술',
  'about.techCard.spec.precision': '정밀도',
  'about.techCard.spec.precision.value': '픽셀 퍼펙트 인페인팅',
  'about.cta.title': '미래를 경험할 준비가 되셨나요?',
  'about.cta.description': '전문 크리에이터 대열에 합류하여 AI의 궁극적인 잠재력을 발휘하세요.',
  'about.cta.button.start': '시작하기',
  'about.cta.button.docs': '문서 읽기',
  
  // Community 커뮤니티
  'community.explore.title': '커뮤니티 탐색',
  'community.explore.subtitle': '영감을 발견하고, 워크플로를 리믹스하며, 수천 명의 AI 크리에이터와 연결하세요.',
  'community.posts': '{count}개 게시물',
  'community.empty': '커뮤니티 채널이 없습니다',
  'community.loadFailed': '로드 실패',
  'community.noPosts': '아직 게시물이 없습니다',
  'community.challenge.loadFailed': '챌린지 데이터 로드 실패',
  
  'common.loadFailed': '로드 실패',
  'common.operationFailed': '작업 실패',
  'common.error': '작업 실패',
  'common.publish': '게시',
  'common.back': '뒤로',
  'common.backToCommunity': '커뮤니티로 돌아가기',
  'common.copy': '복사',
  'common.copied': '복사됨',
  'common.follow': '팔로우',
  'common.processing': '처리 중...',
  'common.viewCount': '{count}회 조회',
  'common.loadMore': '더 보기',
  'common.search': '검색...',
  'common.notFound': '찾을 수 없음',
  'common.description': '설명',
  
  'user.followSuccess': '팔로우했습니다',
  'user.unfollowSuccess': '팔로우 취소했습니다',
  'user.following': '팔로우 중',
  'user.mutual_follow': '맞팔',
  
  'post.untitled': '제목 없는 작품',
  'post.prompt': '프롬프트',
  'post.negativePrompt': '네거티브 프롬프트',
  'post.details': '세부 정보',
  'post.model': '모델',
  'post.resolution': '해상도',
  'post.steps': '스텝',
  'post.cfgScale': '가이던스 스케일',
  'post.remix': '리믹스 / 이것을 시도',
  
  'challenge.status.upcoming': '예정',
  'challenge.status.live': '진행 중',
  'challenge.status.voting': '투표 중',
  'challenge.status.ended': '종료',
  'challenge.status.unknown': '알 수 없음',
  'challenge.allChallenges': '모든 챌린지',
  'challenge.entriesCount': '{count}개 작품',
  'challenge.tab.submissions': '작품',
  'challenge.tab.rules': '규칙 및 정보',
  'challenge.requirements': '요구사항',
  'challenge.req.original': '오리지널 작품만 가능합니다.',
  'challenge.req.model': '모델을 사용해야 합니다: {model}',
  'challenge.req.tags': '태그를 포함해야 합니다:',
  'challenge.req.resolution': '해상도는 최소 1024x1024여야 합니다.',
  'challenge.req.nsfw': 'NSFW 콘텐츠는 금지됩니다.',
  'challenge.timeRemaining': '남은 시간',
  'challenge.startsIn': '시작까지',
  'challenge.notStarted': '챌린지가 아직 시작되지 않았습니다',
  'challenge.closed': '챌린지 종료',
  'challenge.submitEntry': '작품 제출',
  'challenge.viewWinners': '수상자 보기',
  'challenge.readRulesTip': '제출 전 규칙을 읽어주세요',
  'challenge.prizePool': '상금 풀',
  'challenge.totalValue': '총액',
  'challenge.rank.1st': '1위',
  'challenge.rank.2nd': '2위',
  'challenge.rank.3rd': '3위',
  'challenge.share': '챌린지 공유',
  'challenge.noEntries': '아직 작품이 없습니다. 첫 번째 제출자가 되세요!',
  'challenge.noChallenges': '챌린지를 찾을 수 없습니다',
  // MediaTools
  'mediaTools.tab.imageCompress': '이미지 압축',
  'mediaTools.tab.videoCompress': '동영상 압축',
  'mediaTools.tab.audioCompress': '오디오 압축',
  'mediaTools.tab.formatConvert': '형식 변환',
  // ImageCompress
  'imageCompress.title': '전문 이미지 압축 도구',
  'imageCompress.subtitle': '지능형 압축, 전문 품질',
  'imageCompress.upload': '이미지 업로드',
  'imageCompress.addImages': '이미지 추가',
  'imageCompress.uploadToStart': '이미지를 업로드하여 압축 시작',
  'imageCompress.settings': '설정',
  'imageCompress.clearAll': '모두 지우기',
  'imageCompress.totalSavings': '절약 공간',
  'imageCompress.totalSize': '총 크기',
  'imageCompress.quality': '품질',
  'imageCompress.resize': '크기 조정',
  'imageCompress.scalePercent': '확대/축소 %',
  'imageCompress.customPx': '사용자 정의 px',
  'imageCompress.presetSize': '사전 설정 크기',
  'imageCompress.width': '너비',
  'imageCompress.height': '높이',
  'imageCompress.format': '형식',
  'imageCompress.format.auto': '자동 (원본 유지)',
  'imageCompress.format.jpeg': 'JPEG (사진)',
  'imageCompress.format.png': 'PNG (무손실)',
  'imageCompress.format.webp': 'WebP (최적)',
  'imageCompress.pngLossless': 'PNG는 무손실 형식입니다. 품질 슬라이더가 숨겨져 있습니다.',
  'imageCompress.cacheSettings': '캐시 설정',
  'imageCompress.cacheTooltip': '활성화하면 업로드한 이미지가 브라우저 캐시에 저장되며, 페이지 새로고침 후 복원됩니다.',
  'imageCompress.saveToCache': '이미지를 브라우저 캐시에 저장',
  'imageCompress.batchProcessing': '일괄 처리',
  'imageCompress.batchTooltip': '활성화하면 현재 설정으로 모든 {count}개의 이미지에 압축이 적용됩니다.',
  'imageCompress.applyToAll': '모든 이미지에 설정 적용 ({count})',
  'imageCompress.compress': '적용 및 압축',
  'imageCompress.compressAll': '모두 적용 및 압축 ({count})',
  'imageCompress.compressing': '압축 중...',
  'imageCompress.compressAllProgress': '{count}개의 이미지 압축 중...',
  'imageCompress.download': '이미지 다운로드',
  'imageCompress.downloadAll': '모두 다운로드 ({count})',
  'imageCompress.downloadAllCheckbox': '모든 {count}개의 이미지 다운로드',
  'imageCompress.original': '원본',
  'imageCompress.compressed': '압축 후',
  // Messages
  'imageCompress.message.compressed': '압축 성공!',
  'imageCompress.message.larger': '출력 파일이 더 큽니다. 품질을 낮춰보세요.',
  'imageCompress.message.failed': '압축 실패',
  'imageCompress.message.batchSuccess': '{success}개의 이미지 압축 성공{failed}',
  'imageCompress.message.batchFailed': '모든 압축이 실패했습니다',
  'imageCompress.message.noImagesToDownload': '다운로드할 압축 이미지가 없습니다',
  'imageCompress.message.downloading': '{count}개의 이미지 다운로드 중...',
  // Preset sizes
  'imageCompress.preset.instagramPost': 'Instagram 게시물 (1:1)',
  'imageCompress.preset.square': '정사각형 (1:1)',
  'imageCompress.preset.facebookCover': 'Facebook 표지 (16:9)',
  'imageCompress.preset.twitterHeader': 'Twitter 헤더 (3:1)',
  'imageCompress.preset.youtubeThumbnail': 'YouTube 썸네일 (16:9)',
  'imageCompress.preset.facebookPost': 'Facebook 게시물 (1.91:1)',
  'imageCompress.preset.instagramStory': 'Instagram 스토리 (9:16)',
  'imageCompress.preset.tiktok': 'TikTok (9:16)',
  'imageCompress.preset.4kUHD': '4K UHD (16:9)',
  'imageCompress.preset.2kQHD': '2K QHD (16:9)',
  'imageCompress.preset.fullHD': 'Full HD (16:9)',
  'imageCompress.preset.hd': 'HD (16:9)',
  'imageCompress.preset.landscape16:9': '16:9 가로',
  'imageCompress.preset.classic4:3': '4:3 클래식',
  'imageCompress.preset.photo3:2': '3:2 사진',
  'imageCompress.preset.ultrawide21:9': '21:9 울트라와이드',
  'imageCompress.preset.a4Portrait': 'A4 세로 (8.27×11.69")',
  'imageCompress.preset.a4Landscape': 'A4 가로 (11.69×8.27")',
  'imageCompress.preset.letterPortrait': 'Letter 세로 (8.5×11")',
  // AudioCompress
  'audioCompress.title': '전문 오디오 압축 도구',
  'audioCompress.subtitle': '브라우저 기반 압축, 개인정보 보호',
  'audioCompress.upload': '오디오 업로드',
  'audioCompress.uploadNew': '새 오디오 업로드',
  'audioCompress.uploadToStart': '오디오를 업로드하여 압축 시작',
  'audioCompress.settings': '설정',
  'audioCompress.clearAll': '모두 지우기',
  'audioCompress.totalSavings': '절약된 공간',
  'audioCompress.totalSize': '전체 크기',
  'audioCompress.audioInfo': '오디오 정보',
  'audioCompress.quality': '품질',
  'audioCompress.bitrate': '비트레이트',
  'audioCompress.bitrate.320': '320 kbps (최고 품질)',
  'audioCompress.bitrate.256': '256 kbps (고품질)',
  'audioCompress.bitrate.192': '192 kbps (표준 품질)',
  'audioCompress.bitrate.128': '128 kbps (중간 품질)',
  'audioCompress.bitrate.96': '96 kbps (저품질)',
  'audioCompress.bitrate.64': '64 kbps (최저 품질)',
  'audioCompress.format': '형식',
  'audioCompress.format.mp3': 'MP3 (권장)',
  'audioCompress.format.ogg': 'OGG',
  'audioCompress.format.aac': 'AAC',
  'audioCompress.format.wav': 'WAV',
  'audioCompress.sampleRate': '샘플링 레이트',
  'audioCompress.sampleRate.48000': '48000 Hz',
  'audioCompress.sampleRate.44100': '44100 Hz (CD 품질)',
  'audioCompress.sampleRate.32000': '32000 Hz',
  'audioCompress.sampleRate.22050': '22050 Hz',
  'audioCompress.sampleRate.16000': '16000 Hz',
  'audioCompress.compress': '압축 시작',
  'audioCompress.compressing': '압축 중...',
  'audioCompress.download': '오디오 다운로드',
  // AudioCompress Messages
  'audioCompress.message.compressed': '압축 성공!',
  'audioCompress.message.failed': '압축 실패, 다시 시도하세요',
  'audioCompress.message.invalidFile': '오디오 파일을 선택하세요!',
  'audioCompress.message.loadError': '오디오 파일 로드 실패',
  
  // Settings
  'settings.title': '시스템 설정',
  'settings.description': 'AI 생성 플랫폼 경험을 개인화하세요',
  'settings.notifications.title': '알림 설정',
  'settings.notifications.description': '알림 수신 방법 관리',
  'settings.notifications.email': '이메일 알림',
  'settings.notifications.emailDesc': '중요 업데이트 및 작업 완료 이메일 수신',
  'settings.notifications.push': '푸시 알림',
  'settings.notifications.pushDesc': '실시간 푸시 메시지 수신',
  'settings.notifications.sound': '사운드 알림',
  'settings.notifications.soundDesc': '알림 도착 시 사운드 재생',
  'settings.notifications.volume': '알림 볼륨',
  'settings.notifications.volumeDesc': '알림 사운드 볼륨 조정',
  'settings.notifications.marketing': '마케팅',
  'settings.notifications.marketingDesc': '플랫폼 이벤트 및 프로모션 정보 수신',
  'settings.interface.title': '인터페이스 외관',
  'settings.interface.description': '인터페이스 디스플레이 사용자 정의',
  'settings.interface.theme': '테마 모드',
  'settings.interface.themeDesc': '선호하는 인터페이스 테마 선택',
  'settings.interface.language': '언어',
  'settings.interface.languageDesc': '인터페이스 표시 언어 선택',
  'settings.interface.animation': '애니메이션 효과',
  'settings.interface.animationDesc': '인터페이스 전환 애니메이션 활성화',
  'settings.interface.tips': '초보자 팁',
  'settings.interface.tipsDesc': '기능 가이드 및 팁 표시',
  'settings.theme.light': '라이트',
  'settings.theme.dark': '다크',
  'settings.theme.auto': '자동',
  'settings.ai.title': 'AI 생성 설정',
  'settings.ai.description': 'AI 생성 효과 및 성능 최적화',
  'settings.ai.autoOptimize': '스마트 최적화',
  'settings.ai.autoOptimizeDesc': 'AI가 자동으로 생성 매개변수 최적화',
  'settings.ai.quality': '생성 품질',
  'settings.ai.qualityDesc': '속도와 품질 균형',
  'settings.ai.cloudSync': '클라우드 동기화',
  'settings.ai.cloudSyncDesc': '작품을 클라우드에 자동 동기화',
  'settings.ai.autoSave': '자동 저장',
  'settings.ai.autoSaveDesc': '생성 완료 후 결과 자동 저장',
  'settings.ai.safetyFilter': '콘텐츠 안전 필터',
  'settings.ai.safetyFilterDesc': '부적절한 콘텐츠 자동 필터링',
  'settings.ai.watermark': '워터마크 추가',
  'settings.ai.watermarkDesc': '생성된 작품에 자동으로 워터마크 추가',
  'settings.ai.promptSuggestions': '프롬프트 제안',
  'settings.ai.promptSuggestionsDesc': '프롬프트 최적화를 위한 스마트 추천',
  'settings.quality.fast': '빠름',
  'settings.quality.balanced': '균형',
  'settings.quality.high': '고품질',
  'settings.privacy.title': '개인정보 및 보안',
  'settings.privacy.description': '개인 정보 보호',
  'settings.privacy.profile': '프로필 공개 설정',
  'settings.privacy.profileDesc': '다른 사용자가 프로필 조회 가능',
  'settings.privacy.activity': '활동 상태 표시',
  'settings.privacy.activityDesc': '친구가 온라인 상태 확인 가능',
  'settings.privacy.analytics': '분석 데이터 수집',
  'settings.privacy.analyticsDesc': '제품 경험 개선에 도움',
  'settings.privacy.showWorks': '작품 공개 설정',
  'settings.privacy.showWorksDesc': '다른 사용자가 작품 조회 가능',
  'settings.privacy.allowComments': '댓글 허용',
  'settings.privacy.allowCommentsDesc': '다른 사용자가 작품에 댓글 작성 가능',
  'settings.privacy.allowDownload': '다운로드 허용',
  'settings.privacy.allowDownloadDesc': '다른 사용자가 작품 다운로드 가능',
  'settings.performance.title': '성능 최적화',
  'settings.performance.description': '시스템 성능 및 리소스 사용 조정',
  'settings.performance.hardware': '하드웨어 가속',
  'settings.performance.hardwareDesc': '렌더링에 GPU 가속 사용',
  'settings.performance.preview': '미리보기 품질',
  'settings.performance.previewDesc': '미리보기 이미지 품질 수준',
  'settings.performance.autoClean': '자동 캐시 정리',
  'settings.performance.autoCleanDesc': '임시 파일 정기적으로 정리',
  'settings.performance.imageCompression': '이미지 압축',
  'settings.performance.imageCompressionDesc': '업로드된 이미지 자동 압축',
  'settings.performance.lazyLoading': '지연 로딩',
  'settings.performance.lazyLoadingDesc': '페이지 콘텐츠 로딩 지연',
  'settings.preview.low': '낮음',
  'settings.preview.medium': '중간',
  'settings.preview.high': '높음',
  'settings.workflow.title': '워크플로우 설정',
  'settings.workflow.description': 'AI 생성 워크플로우 사용자 정의',
  'settings.workflow.resolution': '기본 해상도',
  'settings.workflow.resolutionDesc': '이미지 생성 기본 크기',
  'settings.workflow.saveHistory': '히스토리 저장',
  'settings.workflow.saveHistoryDesc': '생성 매개변수 및 프롬프트 히스토리 저장',
  'settings.workflow.autoTag': '스마트 태그',
  'settings.workflow.autoTagDesc': '작품에 자동으로 태그 추가',
  'settings.workflow.template': '템플릿 기능',
  'settings.workflow.templateDesc': '워크플로우 템플릿 활성화',
  'settings.file.title': '파일 관리',
  'settings.file.description': '파일 저장소 및 백업 관리',
  'settings.file.autoBackup': '자동 백업',
  'settings.file.autoBackupDesc': '중요한 파일 자동 백업',
  'settings.file.backupFrequency': '백업 빈도',
  'settings.file.backupFrequencyDesc': '백업 빈도 선택',
  'settings.file.realtime': '실시간',
  'settings.file.daily': '매일',
  'settings.file.weekly': '매주',
  'settings.file.autoOrganize': '스마트 정리',
  'settings.file.autoOrganizeDesc': '파일 자동 분류 및 정리',
  'settings.file.defaultFormat': '기본 형식',
  'settings.file.defaultFormatDesc': '파일 저장 기본 형식',
  'settings.social.title': '소셜 기능',
  'settings.social.description': '소셜 기능 및 권한 관리',
  'settings.social.allowFollow': '팔로우 허용',
  'settings.social.allowFollowDesc': '다른 사용자가 팔로우 가능',
  'settings.social.allowMessage': '메시지 허용',
  'settings.social.allowMessageDesc': '다른 사용자가 메시지 전송 가능',
  'settings.social.likeNotify': '좋아요 알림',
  'settings.social.likeNotifyDesc': '작품이 좋아요를 받을 때 알림',
  'settings.social.mentionNotify': '멘션 알림',
  'settings.social.mentionNotifyDesc': '멘션될 때 알림 수신',
  'settings.security.title': '계정 보안',
  'settings.security.description': '계정 보안 보호 강화',
  'settings.security.twoFactor': '2단계 인증',
  'settings.security.twoFactorDesc': '추가 보안 인증 레이어',
  'settings.security.loginNotify': '로그인 알림',
  'settings.security.loginNotifyDesc': '새 기기에서 로그인 시 알림',
  'settings.security.deviceVerify': '기기 인증',
  'settings.security.deviceVerifyDesc': '승인되지 않은 기기는 인증 필요',
  'settings.security.autoLogout': '유휴 시 자동 로그아웃',
  'settings.security.autoLogoutDesc': '장시간 비활성 후 자동 로그아웃',
  'settings.button.save': '설정 저장',
  'settings.button.reset': '기본값으로 재설정',
  'settings.badge.on': '켜짐',
  'settings.badge.recommended': '추천',
  'settings.message.saveSuccess': '설정이 저장되었습니다',
  'settings.message.autoSaved': '설정이 자동 저장되었습니다',
  'settings.message.saveFailed': '저장 실패, 다시 시도하세요',
  'settings.message.resetSuccess': '설정이 기본값으로 재설정되었습니다',
  'settings.autoSaveHint': '설정이 자동으로 저장됩니다',
  'settings.confirm.resetTitle': '재설정 확인',
  'settings.confirm.resetContent': '모든 설정을 기본값으로 재설정하시겠습니까?',
  'settings.confirm.reset': '재설정',
  'settings.confirm.cancel': '취소',

  // Prompt Version History
  'prompt.version.label.prompt': '프롬프트',
  'prompt.version.label.negativePrompt': '네거티브 프롬프트',
  'prompt.version.label.result': '실행 결과',
}; 